// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Match routed dashboard layout so content doesn't sit under the left menu */
.setting-dashboard {
  padding: 0;
  height: auto;
  position: relative;
  background: var(--fc-bg, #fff);
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0;
}
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: absolute;
  top: 0;
  width: 83.333333%;
  padding-left: 0;
  border-left: 1px solid #fff;
}

.dashbored-wrap {
  padding-left: 0;
  margin-top: 0;
}
.dashbored-wrap .table-wrap {
  padding: 30px 30px 30px 0;
  width: 100%;
  left: 0;
}
.dashbored-wrap .filter {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 0;
  border: none;
  padding: 0 0 16px;
}
.dashbored-wrap .table-parent {
  overflow-x: auto;
  margin-top: -8px;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important;
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0;
}

.com-record {
  width: calc(100% - 250px);
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
  border: none !important;
  box-shadow: none !important;
  overflow: visible;
}

/* Summary cards at top (like Incoming Ownership dashboard) */
.flow-reviews-stats {
  margin-bottom: 24px;
  width: 100%;
  /* Skeleton loading for cards */
}
.flow-reviews-stats.followers-tag {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  position: relative;
  z-index: 1;
}
.flow-reviews-stats.followers-tag .box {
  padding: 5px 10px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: 180px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.flow-reviews-stats.followers-tag .box:hover {
  transform: translateY(-2px);
  box-shadow: 2px 4px 30px rgba(0, 0, 0, 0.2);
}
.flow-reviews-stats.followers-tag .box .icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flow-reviews-stats.followers-tag .box .ico-box {
  width: 40px;
  height: 40px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  box-shadow: none !important;
}
.flow-reviews-stats.followers-tag .box .card-icon {
  font-size: 24px;
  color: #5ea1d8;
}
.flow-reviews-stats.followers-tag .box .text {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
  justify-content: center;
  gap: 2px;
}
.flow-reviews-stats.followers-tag .box .text .count {
  background: white !important;
  box-shadow: none !important;
}
.flow-reviews-stats.followers-tag .box .text .count b {
  font-size: 24px;
  font-weight: 700 !important;
  color: #333;
  display: block;
  line-height: 1.2;
}
.flow-reviews-stats.followers-tag .box .text p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.2;
  text-align: left;
}
.flow-reviews-stats.skeleton-stats-container .box {
  min-width: 180px;
}
.flow-reviews-stats .skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
  height: 24px;
  min-width: 60px;
}
.flow-reviews-stats .skeleton-box .ico-box.skeleton-text {
  width: 40px;
  height: 40px;
  min-width: 40px;
}
.flow-reviews-stats .skeleton-box .text .skeleton-text {
  height: 20px;
  min-width: 80px;
}
@media (max-width: 768px) {
  .flow-reviews-stats.followers-tag .box {
    min-width: 100%;
    width: 100%;
  }
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.moderation-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.moderation-badge.moderation-pending {
  background: #fff3cd;
  color: #856404;
}
.moderation-badge.moderation-resolved {
  background: #d4edda;
  color: #155724;
}

.filters-section {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: nowrap;
  align-items: center;
  overflow: visible;
  width: 100%;
}
.filters-section .flow-filter {
  display: flex;
  align-items: center;
  align-self: center;
  flex: 0 0 auto;
  min-width: 180px;
  max-width: 220px;
}
.filters-section .flow-filter .status-filter {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #fff;
  font-size: 14px;
  font: inherit;
  color: #333;
}
.filters-section .search-and-flow-filter {
  position: relative;
  flex: 1 1 auto;
  min-width: 240px;
  max-width: 640px;
  align-self: center;
}
.filters-section .search-and-flow-filter .search-field {
  width: 100%;
  /* Remove subscript gap so search lines up with status select + toggle */
}
.filters-section .search-and-flow-filter .search-field ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.filters-section .search-and-flow-filter .search-field ::ng-deep .mat-mdc-text-field-wrapper {
  width: 100%;
}
.filters-section .search-and-flow-filter .search-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.filters-section .search-and-flow-filter .search-field ::ng-deep .mat-mdc-form-field-infix {
  min-height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.filters-section .search-and-flow-filter .search-field ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 20px;
}
.filters-section .search-and-flow-filter .search-field ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {
  --mat-mdc-form-field-label-transform: translateY(-26.75px) scale(var(--mat-mdc-form-field-floating-label-scale, 0.75));
  transform: var(--mat-mdc-form-field-label-transform);
}
.filters-section .search-and-flow-filter .flow-filter-dropdown-panel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  padding: 8px 0;
}
.filters-section .search-and-flow-filter .flow-dropdown-option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: none;
  text-align: left;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  font-family: inherit;
  gap: 10px;
  transition: background-color 0.15s ease;
}
.filters-section .search-and-flow-filter .flow-dropdown-option .option-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #5ea1d8;
}
.filters-section .search-and-flow-filter .flow-dropdown-option:hover {
  background-color: #f5f9ff;
}
.filters-section .search-and-flow-filter .flow-dropdown-option.selected {
  background-color: #e8f4fd;
  color: #1a67a8;
  font-weight: 500;
}
.filters-section .search-and-flow-filter .flow-dropdown-empty {
  padding: 16px;
  font-size: 13px;
  color: #666;
  text-align: center;
}
.filters-section .view-toggle {
  display: flex;
  align-items: center;
  align-self: center;
  flex: 0 0 auto;
  margin-left: auto;
  height: 40px;
}
.filters-section .view-toggle button {
  color: #5ea1d8;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding: 0 !important;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  min-height: 40px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.filters-section .view-toggle button:hover {
  background-color: rgba(94, 161, 216, 0.1) !important;
}
.filters-section .view-toggle button:focus {
  outline: none !important;
}

.flow-reviews-container {
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
}
.flow-reviews-container .flow-analytics-section {
  margin-bottom: 24px;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  flex-wrap: wrap;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-heading .section-icon {
  color: #5ea1d8;
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-heading .analytics-count-badge {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  background: #f0f0f0;
  padding: 2px 8px;
  border-radius: 12px;
  margin-left: 4px;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-show-more {
  margin-top: 16px;
  text-align: center;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-show-more button {
  font-weight: 500;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-card {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-card .flow-analytics-card-header {
  margin-bottom: 12px;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-card .flow-analytics-card-header .flow-title-link {
  font-size: 15px;
  font-weight: 500;
  color: #5ea1d8;
  cursor: pointer;
  text-decoration: none;
}
.flow-reviews-container .flow-analytics-section .flow-analytics-card .flow-analytics-card-header .flow-title-link:hover {
  text-decoration: underline;
}
.flow-reviews-container .loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}
.flow-reviews-container .loading-section p {
  margin-top: 16px;
  color: #666;
}
.flow-reviews-container .no-reviews {
  text-align: center;
  padding: 60px 20px;
}
.flow-reviews-container .no-reviews mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #ccc;
  margin-bottom: 16px;
}
.flow-reviews-container .no-reviews h3 {
  margin: 0 0 8px 0;
  color: #666;
}
.flow-reviews-container .no-reviews p {
  margin: 0;
  color: #999;
}
.flow-reviews-container .table-view-container {
  width: 100%;
}
.flow-reviews-container .table-view-container .table-action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f9f9f9;
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
}
.flow-reviews-container .table-view-container .table-action-bar .selection-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
.flow-reviews-container .table-view-container .table-action-bar .selection-info .selected-count {
  font-weight: 500;
  color: #333;
}
.flow-reviews-container .table-view-container .table-action-bar .table-actions {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.flow-reviews-container .table-view-container .table-action-bar .table-actions button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  text-transform: none;
  white-space: nowrap;
  flex-shrink: 0;
}
.flow-reviews-container .table-view-container .table-action-bar .table-actions button.btn-primary {
  background-color: #5ea1d8;
  color: white;
}
.flow-reviews-container .table-view-container .table-action-bar .table-actions button.btn-secondary {
  background-color: #f3f4f6;
  color: #333;
}
.flow-reviews-container .table-view-container .table-action-bar .table-actions button.btn-delete {
  background-color: #f44336;
  color: white;
}
.flow-reviews-container .table-view-container .table-action-bar .table-actions button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.flow-reviews-container .table-view-container .reviews-table {
  width: 100%;
  background: white;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}
.flow-reviews-container .table-view-container .reviews-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  padding: 16px;
  border-bottom: 2px solid #e0e0e0;
}
.flow-reviews-container .table-view-container .reviews-table td {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}
.flow-reviews-container .table-view-container .reviews-table tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
.flow-reviews-container .table-view-container .reviews-table tr:hover {
  background-color: #f9f9f9;
}
.flow-reviews-container .table-view-container .reviews-table tr:last-child td {
  border-bottom: none;
}
.flow-reviews-container .table-view-container .reviews-table tr.table-row:hover {
  background-color: #f5f5f5;
}
.flow-reviews-container .table-view-container .reviews-table .user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}
.flow-reviews-container .table-view-container .reviews-table .user-cell .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
}
.flow-reviews-container .table-view-container .reviews-table .user-cell .user-avatar.user-avatar-img {
  object-fit: cover;
  border: none;
  padding: 0;
}
.flow-reviews-container .table-view-container .reviews-table .user-cell .user-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.flow-reviews-container .table-view-container .reviews-table .user-cell .user-info .user-name {
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flow-reviews-container .table-view-container .reviews-table .user-cell .user-info .user-time {
  font-size: 12px;
  color: #999;
}
.flow-reviews-container .table-view-container .reviews-table .flow-link-cell {
  color: #5ea1d8;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}
.flow-reviews-container .table-view-container .reviews-table .flow-link-cell:hover {
  text-decoration: underline;
}
.flow-reviews-container .table-view-container .reviews-table .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.flow-reviews-container .table-view-container .reviews-table .status-badge.completed {
  background-color: #e8f5e9;
  color: #4caf50;
}
.flow-reviews-container .table-view-container .reviews-table .status-badge.failed {
  background-color: #ffebee;
  color: #f44336;
}
.flow-reviews-container .table-view-container .reviews-table .status-badge mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.flow-reviews-container .table-view-container .reviews-table .status-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.flow-reviews-container .table-view-container .reviews-table .rating-cell {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}
.flow-reviews-container .table-view-container .reviews-table .rating-cell .star-icon {
  color: #ffc107;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.flow-reviews-container .table-view-container .reviews-table .snippet-cell .view-snippet-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #5ea1d8;
  padding: 4px 8px;
  min-width: auto;
}
.flow-reviews-container .table-view-container .reviews-table .snippet-cell .view-snippet-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.flow-reviews-container .table-view-container .reviews-table .snippet-cell .no-snippet {
  color: #999;
}
.flow-reviews-container .table-view-container .reviews-table .media-cell .media-icon-btn {
  min-width: auto;
  padding: 4px;
  color: #5ea1d8;
}
.flow-reviews-container .table-view-container .reviews-table .media-cell .media-icon-btn .media-icon {
  color: #5ea1d8;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.flow-reviews-container .table-view-container .reviews-table .media-cell .media-icon-btn:hover {
  background-color: rgba(94, 161, 216, 0.1);
}
.flow-reviews-container .table-view-container .reviews-table .media-cell .no-media {
  color: #999;
}
.flow-reviews-container .review-details-overlay {
  position: fixed;
  top: var(--app-header, 56px);
  left: 16.666667%;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000 !important;
  padding: 20px;
}
.flow-reviews-container .review-details-overlay .review-details-modal {
  background: white;
  border-radius: 22px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  border: none;
  overflow: hidden;
  position: relative;
  z-index: 10001 !important;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: white;
  position: sticky;
  top: 0;
  z-index: 20;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-info .header-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(95, 162, 216, 0.2);
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-info .header-avatar.header-avatar-initials {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 18px;
  border: none;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-info .header-user-details .header-user-name {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #212427;
  line-height: 1.2;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-info .header-user-details .header-flow-name {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #666;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-info .header-user-details .header-flow-name .flow-name-link {
  color: #5ea1d8;
  font-weight: 500;
  cursor: pointer;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-info .header-user-details .header-flow-name .flow-name-link:hover {
  text-decoration: underline;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .close-btn-new {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #666;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .close-btn-new mat-icon {
  color: #666;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .close-btn-new:hover {
  background-color: #f1f5f9;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new::-webkit-scrollbar {
  width: 6px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new::-webkit-scrollbar-track {
  background: transparent;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid {
  display: grid;
  grid-template-columns: 1fr;
  border-top: none;
}
@media (min-width: 1024px) {
  .flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid {
    grid-template-columns: 1fr;
    border-top: none;
  }
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column {
  padding: 20px 24px;
  border-right: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background-color: #f8f8f8;
  border-radius: 12px;
  margin-bottom: 4px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .rating-date {
  display: flex;
  align-items: center;
  gap: 12px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .rating-date .star-rating-modal {
  display: flex;
  gap: 2px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .rating-date .star-rating-modal .star-icon-modal {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #d1d5db;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .rating-date .star-rating-modal .star-icon-modal.filled {
  color: #ffc107;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .rating-date .star-rating-modal .star-icon-modal.half {
  color: #ffc107;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .rating-date .review-date-modal {
  font-size: 12px;
  font-weight: 500;
  color: #666;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .status-badge-modal {
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  background-color: #e3f2fd;
  color: #1565c0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .status-badge-modal.completed {
  background-color: #c8e6c9;
  color: #1b5e20;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .rating-status-section .status-badge-modal.failed {
  background-color: #ffebee;
  color: #c62828;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .review-text-section .review-title-modal {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #212427;
  line-height: 1.4;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .review-text-section .review-text-modal {
  margin: 0;
  color: #666;
  line-height: 1.6;
  font-size: 14px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-title {
  font-size: 14px;
  font-weight: 600;
  color: #212427;
  margin: 0 0 12px 0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
@media (min-width: 640px) {
  .flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid {
    grid-template-columns: 1fr 1fr;
  }
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid .gallery-item {
  position: relative;
  aspect-ratio: 16/9;
  border-radius: 12px;
  overflow: hidden;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid .gallery-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid .gallery-item .gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid .gallery-item .gallery-video-overlay {
  position: relative;
  width: 100%;
  height: 100%;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid .gallery-item .gallery-video-overlay .gallery-image {
  opacity: 1;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid .gallery-item .gallery-video-overlay .play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column .gallery-section .gallery-grid .gallery-item .more-indicator {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-weight: 700;
  font-size: 18px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column {
  padding: 24px;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .section-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .section-title .section-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .stats-section .stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .stats-section .stats-grid .stat-card {
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .stats-section .stats-grid .stat-card .stat-label {
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
  color: #64748b;
  margin: 0 0 4px 0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .stats-section .stats-grid .stat-card .stat-value-primary {
  font-size: 20px;
  font-weight: 700;
  color: #5fa2d8;
  margin: 0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .stats-section .stats-grid .stat-card .stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .stats-section .progress-bar-container {
  width: 100%;
  background-color: #e3f2fd;
  border-radius: 9999px;
  height: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .stats-section .progress-bar-container .progress-bar {
  height: 100%;
  background-color: #5fa2d8;
  border-radius: 9999px;
  transition: width 0.3s ease;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .stats-section .progress-note {
  font-size: 12px;
  color: #64748b;
  font-style: italic;
  text-align: center;
  margin: 0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .feedback-section .feedback-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .feedback-section .feedback-list .feedback-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid rgba(95, 162, 216, 0.1);
  background-color: rgba(95, 162, 216, 0.05);
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .feedback-section .feedback-list .feedback-item.feedback-negative {
  border-color: rgba(232, 62, 140, 0.1);
  background-color: rgba(232, 62, 140, 0.05);
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .feedback-section .feedback-list .feedback-item .feedback-step {
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .feedback-section .feedback-list .feedback-item .feedback-icon {
  color: #5fa2d8;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .feedback-section .feedback-list .feedback-item .feedback-icon.feedback-icon-error {
  color: #e83e8c;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .notes-section .notes-textarea {
  width: 100%;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  padding: 12px;
  color: #0f172a;
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;
  box-sizing: border-box;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .notes-section .notes-textarea:focus {
  outline: none;
  border-color: #5fa2d8;
  box-shadow: 0 0 0 3px rgba(95, 162, 216, 0.1);
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .notes-section .notes-textarea::placeholder {
  color: #94a3b8;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-right-column .notes-section .notes-hint {
  font-size: 10px;
  color: #64748b;
  font-style: italic;
  margin: 8px 0 0 0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new {
  padding: 20px 24px;
  background: #fafafa;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .response-section .response-label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin-bottom: 8px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .response-section .response-textarea-new {
  width: 100%;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 14px;
  padding: 16px;
  color: #0f172a;
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
  transition: all 0.2s;
  box-sizing: border-box;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .response-section .response-textarea-new:focus {
  outline: none;
  border-color: #5fa2d8;
  box-shadow: 0 0 0 3px rgba(95, 162, 216, 0.1);
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .response-section .response-textarea-new::placeholder {
  color: #94a3b8;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: nowrap;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .response-visibility {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .response-visibility mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  white-space: nowrap;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .flag-btn,
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .post-response-btn {
  min-width: 140px;
  height: 40px;
  line-height: 40px;
  padding-top: 0;
  padding-bottom: 0;
  margin: 0 !important;
  white-space: nowrap !important;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .flag-btn .mdc-button__label,
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .post-response-btn .mdc-button__label {
  white-space: nowrap !important;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .flag-btn {
  background-color: #f3f4f6;
  color: #374151;
  font-weight: 600;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 24px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .flag-btn:hover {
  background-color: #e5e7eb;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .flag-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .post-response-btn {
  background-color: #5fa2d8 !important;
  color: white !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  border-radius: 8px !important;
  padding: 10px 32px !important;
  box-shadow: 0 4px 6px -1px rgba(95, 162, 216, 0.2) !important;
  transition: all 0.2s !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}
.flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new .footer-actions .footer-buttons .post-response-btn:hover {
  background-color: #4a90c6 !important;
  box-shadow: 0 6px 8px -1px rgba(95, 162, 216, 0.3) !important;
}
.flow-reviews-container .reviews-list-card {
  /* Match Access Requests card list layout */
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 20px;
}
.flow-reviews-container .reviews-list-card .review-card-modern {
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
.flow-reviews-container .reviews-list-card .review-card-modern:hover {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
}
.flow-reviews-container .reviews-list-card .review-card-modern .card-content {
  padding: 24px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
@media (min-width: 640px) {
  .flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .reviewer-info-modern {
  display: flex;
  align-items: center;
  gap: 12px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .reviewer-info-modern .reviewer-avatar-modern {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 16px;
  flex-shrink: 0;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .reviewer-info-modern .reviewer-avatar-modern.reviewer-avatar-img {
  object-fit: cover;
  border: none;
  padding: 0;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .reviewer-info-modern .reviewer-details-modern {
  display: flex;
  flex-direction: column;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .reviewer-info-modern .reviewer-details-modern .reviewer-name-modern {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .reviewer-info-modern .reviewer-details-modern .review-date-modern {
  font-size: 12px;
  color: #94a3b8;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .flow-link-modern {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #5ea1d8;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .flow-link-modern:hover {
  text-decoration: underline;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-header-modern .flow-link-modern mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges .status-badge-modern {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges .status-badge-modern.completed {
  background-color: #dcfce7;
  color: #16a34a !important;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges .status-badge-modern.failed {
  background-color: #fee2e2;
  color: #dc2626 !important;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges .status-badge-modern mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges .star-rating {
  display: flex;
  gap: 2px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges .star-rating .star-icon-modern {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #d1d5db;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges .star-rating .star-icon-modern.filled {
  color: #fbbf24;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-badges .star-rating .star-icon-modern.half {
  color: #fbbf24;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 32px;
}
@media (min-width: 768px) {
  .flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid {
    grid-template-columns: 1fr 200px;
  }
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-text-modern p {
  margin: 0;
  color: #334155;
  line-height: 1.75;
  font-size: 15px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #f1f5f9;
  cursor: pointer;
  height: 128px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview:hover:not(.has-error) img {
  transform: scale(1.05);
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview .media-overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview .media-overlay mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: white;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview:hover:not(.has-error) .media-overlay {
  opacity: 1;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview .error-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  background-color: rgba(241, 245, 249, 0.5);
  z-index: 2;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview .error-overlay mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview .error-overlay span {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview.has-video .media-overlay {
  opacity: 0;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview.has-video:hover .media-overlay {
  opacity: 1;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-content-grid .review-media-modern .media-preview.has-error img {
  opacity: 0.5;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #f1f5f9;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern h4 {
  margin: 0 0 16px 0;
  color: #0f172a;
  font-size: 16px;
  font-weight: 600;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 12px;
  border-left: 4px solid #ff9800;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-header-modern {
  margin-bottom: 8px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-header-modern strong {
  color: #0f172a;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-description-modern {
  margin: 8px 0;
  color: #64748b;
  line-height: 1.6;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-media-modern {
  margin: 12px 0;
  border-radius: 8px;
  overflow: hidden;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-media-modern img,
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-media-modern video {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-response-modern {
  margin-top: 12px;
  padding: 12px;
  background-color: #dbeafe;
  border-radius: 8px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-response-modern .response-header-modern {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-response-modern .response-header-modern mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #5ea1d8;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-response-modern .response-header-modern strong {
  color: #0f172a;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-response-modern .response-header-modern .response-date-modern {
  margin-left: auto;
  font-size: 12px;
  color: #94a3b8;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .issue-response-modern p {
  margin: 0;
  color: #64748b;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .response-input-modern {
  margin-top: 12px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .response-input-modern .full-width {
  width: 100%;
  margin-bottom: 8px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .response-input-modern .submit-btn-modern {
  font-family: "Raleway" !important;
  min-width: 140px !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 24px !important;
  margin: 0 !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  background-color: #5fa2d8 !important;
  color: white !important;
  box-shadow: 0 4px 6px -1px rgba(95, 162, 216, 0.2) !important;
  transition: all 0.2s !important;
  white-space: nowrap !important;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .response-input-modern .submit-btn-modern .mdc-button__label {
  white-space: nowrap !important;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-issues-modern .issue-item-modern .response-input-modern .submit-btn-modern:hover {
  background-color: #4a90c6 !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15) !important;
  transform: scale(0.98) !important;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f1f5f9;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .info-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background-color: #dbeafe;
  border-radius: 12px;
  border: 1px solid #bfdbfe;
  margin-bottom: 16px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .info-banner mat-icon {
  color: #5ea1d8;
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .info-banner p {
  margin: 0;
  font-size: 14px;
  color: #1e40af;
  line-height: 1.5;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .review-response-modern {
  margin-bottom: 16px;
  padding: 12px;
  background-color: #dbeafe;
  border-radius: 8px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .review-response-modern .response-header-modern {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .review-response-modern .response-header-modern mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #5ea1d8;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .review-response-modern .response-header-modern strong {
  color: #0f172a;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .review-response-modern .response-header-modern .response-date-modern {
  margin-left: auto;
  font-size: 12px;
  color: #94a3b8;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .review-response-modern p {
  margin: 0;
  color: #64748b;
  line-height: 1.6;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .response-input-modern .response-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .response-input-modern .response-textarea {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-family: inherit;
  font-size: 14px;
  color: #0f172a;
  resize: vertical;
  transition: all 0.2s;
  box-sizing: border-box;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .response-input-modern .response-textarea:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .response-input-modern .response-textarea::placeholder {
  color: #94a3b8;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .response-input-modern .response-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .response-input-modern .response-actions .submit-btn-modern {
  font-family: "Raleway" !important;
  min-width: 140px !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 24px !important;
  margin: 0 !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  background-color: #5fa2d8 !important;
  color: white !important;
  box-shadow: 0 4px 6px -1px rgba(95, 162, 216, 0.2) !important;
  transition: all 0.2s !important;
}
.flow-reviews-container .reviews-list-card .review-card-modern .review-response-section .response-input-modern .response-actions .submit-btn-modern:hover {
  background-color: #4a90c6 !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15) !important;
  transform: scale(0.98) !important;
}
.flow-reviews-container .reviews-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.flow-reviews-container .reviews-list .review-card {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.1);
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
.flow-reviews-container .reviews-list .review-card .review-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  gap: 12px;
  min-width: 0;
}
.flow-reviews-container .reviews-list .review-card .review-header .reviewer-info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
}
.flow-reviews-container .reviews-list .review-card .review-header .reviewer-info .reviewer-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.flow-reviews-container .reviews-list .review-card .review-header .reviewer-info .reviewer-avatar-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: #999;
}
.flow-reviews-container .reviews-list .review-card .review-header .reviewer-info .reviewer-details {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}
.flow-reviews-container .reviews-list .review-card .review-header .reviewer-info .reviewer-details .reviewer-name {
  font-weight: 500;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-header .reviewer-info .reviewer-details .review-date {
  font-size: 12px;
  color: #999;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.flow-reviews-container .reviews-list .review-card .review-header .flow-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #5ea1d8;
  cursor: pointer;
  font-weight: 500;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 50%;
  min-width: 0;
}
.flow-reviews-container .reviews-list .review-card .review-header .flow-link:hover {
  text-decoration: underline;
}
.flow-reviews-container .reviews-list .review-card .review-header .flow-link mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.flow-reviews-container .reviews-list .review-card .review-header .flow-link span {
  word-wrap: break-word;
  overflow-wrap: break-word;
  min-width: 0;
}
.flow-reviews-container .reviews-list .review-card .review-content .completion-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.flow-reviews-container .reviews-list .review-card .review-content .completion-status mat-icon.completed {
  color: #4caf50;
}
.flow-reviews-container .reviews-list .review-card .review-content .completion-status mat-icon.issues {
  color: #ff9800;
}
.flow-reviews-container .reviews-list .review-card .review-content .completion-status span {
  font-weight: 500;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-text {
  margin-bottom: 16px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-text p {
  margin: 0;
  color: #666;
  line-height: 1.6;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-media {
  margin-bottom: 16px;
  border-radius: 4px;
  overflow: hidden;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-media img,
.flow-reviews-container .reviews-list .review-card .review-content .review-media video {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues h4 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 16px;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border-left: 4px solid #ff9800;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-header {
  margin-bottom: 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-header strong {
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-description {
  margin: 8px 0;
  color: #666;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-media {
  margin: 12px 0;
  border-radius: 6px;
  overflow: hidden;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-media img,
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-media video {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-response {
  margin-top: 12px;
  padding: 12px;
  background-color: #e3f2fd;
  border-radius: 6px;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-response .response-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-response .response-header mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #5ea1d8;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-response .response-header strong {
  color: #333;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-response .response-header .response-date {
  margin-left: auto;
  font-size: 12px;
  color: #999;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .issue-response p {
  margin: 0;
  color: #666;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input {
  margin-top: 12px;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input .full-width {
  width: 100%;
  margin-bottom: 8px;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input .full-width ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input .full-width ::ng-deep .mat-mdc-text-field-wrapper {
  width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input button.mat-raised-button {
  font-family: "Raleway" !important;
  min-width: 100px !important;
  height: auto !important;
  min-height: auto !important;
  font-weight: normal !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border-radius: 10px !important;
  transition: all 0.3s ease !important;
  padding: 10px !important;
  border: none !important;
  cursor: pointer !important;
  line-height: 1.5 !important;
  margin-top: 8px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  color: white !important;
  background-color: #5ea1d8 !important;
  box-shadow: none !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: center !important;
  font-size: 15px !important;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input button.mat-raised-button ::ng-deep .mat-button-wrapper,
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input button.mat-raised-button ::ng-deep .mdc-button__label {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: center !important;
  display: inline-block !important;
  line-height: 1.5 !important;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input button.mat-raised-button:hover {
  background-color: #4a90c6 !important;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-issues .issue-item .response-input button.mat-raised-button:active {
  background-color: #3a7fb6 !important;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-response {
  margin-top: 16px;
  padding: 12px;
  background-color: #e3f2fd;
  border-radius: 6px;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-response .response-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-response .response-header mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #5ea1d8;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-response .response-header strong {
  color: #333;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-response .response-header .response-date {
  margin-left: auto;
  font-size: 12px;
  color: #999;
}
.flow-reviews-container .reviews-list .review-card .review-content .review-response p {
  margin: 0;
  color: #666;
}
.flow-reviews-container .reviews-list .review-card .review-content .response-input {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.flow-reviews-container .reviews-list .review-card .review-content .response-input .full-width {
  width: 100%;
  margin-bottom: 12px;
}
.flow-reviews-container .reviews-list .review-card .review-content .response-input .full-width ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .response-input .full-width ::ng-deep .mat-mdc-text-field-wrapper {
  width: 100%;
}
.flow-reviews-container .reviews-list .review-card .review-content .response-input button.mat-raised-button {
  font-family: "Raleway" !important;
  min-width: 100px !important;
  height: auto !important;
  min-height: auto !important;
  font-weight: normal !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border-radius: 10px !important;
  transition: all 0.3s ease !important;
  padding: 10px !important;
  border: none !important;
  cursor: pointer !important;
  line-height: 1.5 !important;
  margin-top: 8px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  color: white !important;
  background-color: #5ea1d8 !important;
  box-shadow: none !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: center !important;
  font-size: 15px !important;
}
.flow-reviews-container .reviews-list .review-card .review-content .response-input button.mat-raised-button ::ng-deep .mat-button-wrapper,
.flow-reviews-container .reviews-list .review-card .review-content .response-input button.mat-raised-button ::ng-deep .mdc-button__label {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: center !important;
  display: inline-block !important;
  line-height: 1.5 !important;
}
.flow-reviews-container .reviews-list .review-card .review-content .response-input button.mat-raised-button:hover {
  background-color: #4a90c6 !important;
}
.flow-reviews-container .reviews-list .review-card .review-content .response-input button.mat-raised-button:active {
  background-color: #3a7fb6 !important;
}

@media (max-width: 768px) {
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0;
    position: relative;
  }
  .dashbored-wrap .table-wrap {
    padding: 0;
  }
  .com-record {
    padding: 12px 16px 20px;
  }
  /* Search and filter bar: full width on mobile (global) */
  .filter,
  .filters-section {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .filters-section {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 16px;
    padding: 0 20px;
  }
  .filters-section .search-and-flow-filter,
  .filters-section .flow-filter {
    flex: 1 1 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .filters-section .search-field,
  .filters-section .search-field ::ng-deep .mat-mdc-form-field,
  .filters-section .search-field ::ng-deep .mat-mdc-text-field-wrapper {
    width: 100% !important;
    max-width: 100% !important;
  }
  .flow-reviews-container {
    padding: 0;
    /* Flow analytics graph cards: single column, full width, chart responsive */
  }
  .flow-reviews-container .flow-analytics-section {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .flow-reviews-container .flow-analytics-grid {
    display: grid !important;
    grid-template-columns: 1fr !important;
    gap: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  .flow-reviews-container .flow-analytics-card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 12px 12px 16px;
    overflow: hidden;
  }
  .flow-reviews-container .flow-analytics-card-header .flow-title-link {
    word-break: break-word;
    display: block;
  }
  .flow-reviews-container .flow-analytics-card app-flow-analytics-chart,
  .flow-reviews-container .flow-analytics-card ::ng-deep .flow-analytics-chart,
  .flow-reviews-container .flow-analytics-card ::ng-deep .chart-container {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .flow-reviews-container .flow-analytics-card ::ng-deep .chart-container canvas {
    max-width: 100% !important;
    height: auto !important;
  }
  .flow-reviews-container .table-view-container {
    overflow-x: auto;
  }
  .flow-reviews-container .table-view-container .table-action-bar {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  .flow-reviews-container .table-view-container .table-action-bar .table-actions {
    flex-wrap: wrap;
  }
  .flow-reviews-container .table-view-container .reviews-table {
    min-width: 800px;
  }
  .flow-reviews-container .reviews-list {
    margin-top: 16px;
  }
  .flow-reviews-container .reviews-list .review-card-modern {
    border-radius: 12px;
    padding: 16px;
  }
  .flow-reviews-container .reviews-list .review-card-modern .review-header-modern {
    flex-direction: column;
    gap: 12px;
  }
  .flow-reviews-container .reviews-list .review-card .review-header {
    flex-direction: column;
    gap: 12px;
  }
  .flow-reviews-container .reviews-list .review-card .review-header .flow-link {
    align-self: flex-start;
  }
  .flow-reviews-container .review-details-overlay {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px;
    align-items: flex-start;
    justify-content: center;
  }
  .flow-reviews-container .review-details-overlay .review-details-modal {
    max-height: 95vh;
    max-width: calc(100vw - 16px);
    width: 100%;
    border-radius: 16px;
    margin: 8px;
  }
  .flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new {
    padding: 16px;
  }
  .flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-details .header-user-name {
    font-size: 16px;
    padding-right: 40px;
  }
  .flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .header-user-details .header-flow-name {
    font-size: 12px;
  }
  .flow-reviews-container .review-details-overlay .review-details-modal .modal-header-new .close-btn-new {
    top: 8px;
    right: 8px;
  }
  .flow-reviews-container .review-details-overlay .review-details-modal .modal-body-new .modal-grid .modal-left-column {
    padding: 16px;
  }
  .flow-reviews-container .review-details-overlay .review-details-modal .modal-footer-new {
    padding: 16px;
  }
}
/* Flow name dropdown panel: keep inside viewport and scroll */
/* For Angular Material v15+ where panelClass is applied to the panel element */
::ng-deep .mat-mdc-select-panel.flow-filter-select-panel,
::ng-deep .cdk-overlay-pane.flow-filter-select-panel .mat-mdc-select-panel {
  z-index: 1100 !important;
  max-height: min(70vh, 400px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-width: min(420px, 100vw - 32px) !important;
  width: auto !important;
}

/* Long flow titles: truncate with ellipsis so panel width stays under control */
::ng-deep .mat-mdc-select-panel.flow-filter-select-panel .mat-mdc-option .mdc-list-item__primary-text,
::ng-deep .cdk-overlay-pane.flow-filter-select-panel .mat-mdc-option .mdc-list-item__primary-text {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
}

:host-context(body.theme-dark) .dashbored-wrap,
:host-context(body.theme-dark) .setting-dashboard,
:host-context(body.theme-dark) .scroll-div,
:host-context(body.theme-dark) .flow-reviews-container,
:host-context(body.theme-dark) .com-record,
:host-context(body.theme-dark) .table-wrap,
:host-context(body.theme-dark) .table-view-container,
:host-context(body.theme-dark) .filter,
:host-context(body.theme-dark) .filters-section,
:host-context(body.theme-dark) .search-input,
:host-context(body.theme-dark) .detail-list {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .flow-analytics-card {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .flow-analytics-card .flow-analytics-card-header {
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .flow-analytics-card .flow-title-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .flow-analytics-card p, :host-context(body.theme-dark) .flow-analytics-card span:not(.material-icons):not(.status-badge-modern):not([class*=badge]):not([class*=status-]), :host-context(body.theme-dark) .flow-analytics-card h4 {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) table, :host-context(body.theme-dark) thead, :host-context(body.theme-dark) tbody, :host-context(body.theme-dark) tr, :host-context(body.theme-dark) td {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) th {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) tbody tr:hover {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .box {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) p, :host-context(body.theme-dark) span:not(.material-icons):not(.status-badge-modern):not([class*=badge]):not([class*=status-]), :host-context(body.theme-dark) label, :host-context(body.theme-dark) li, :host-context(body.theme-dark) h1, :host-context(body.theme-dark) h2, :host-context(body.theme-dark) h3, :host-context(body.theme-dark) h4, :host-context(body.theme-dark) h5, :host-context(body.theme-dark) h6, :host-context(body.theme-dark) i, :host-context(body.theme-dark) b {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .mobile-design {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .mobile-design .tile {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .skeleton-text {
  background: linear-gradient(90deg, #1f2937 25%, #374151 37%, #1f2937 63%) !important;
  background-size: 400% 100% !important;
}
:host-context(body.theme-dark) .reviews-list .review-card-modern {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .reviews-list .review-card-modern .review-header-modern {
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .reviews-list .review-card-modern .flow-name-modern {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .reviews-list .review-card-modern .reviewer-name-modern {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .reviews-list .review-card-modern .review-date-modern {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .reviews-list .review-card-modern .review-comment-modern {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .review-details-overlay {
  background: rgba(0, 0, 0, 0.7) !important;
}
:host-context(body.theme-dark) .review-details-modal {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .review-details-modal .modal-header-new {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .review-details-modal .header-user-name {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .review-details-modal .header-flow-name {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .review-details-modal .modal-body-new {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .review-details-modal .modal-footer-new {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .review-details-modal .review-issues-modern .issue-item-modern {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .review-details-modal .review-issues-modern .issue-item-modern .issue-header-modern strong {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .review-details-modal .review-issues-modern .issue-item-modern .issue-description-modern {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .filters-section .status-filter {
  background: #0f172a !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .flow-filter-dropdown-panel {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;
}
:host-context(body.theme-dark) .flow-dropdown-option {
  background: #0f172a !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .flow-dropdown-option .option-icon {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .flow-dropdown-option:hover {
  background-color: rgba(148, 163, 184, 0.12) !important;
}
:host-context(body.theme-dark) .flow-dropdown-option.selected {
  background-color: rgba(94, 161, 216, 0.18) !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .flow-dropdown-empty {
  color: #94a3b8 !important;
}

body.theme-dark .dashbored-wrap,
body.theme-dark .setting-dashboard {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .top-menu-wrap,
body.theme-dark .dashbored-wrap .box,
body.theme-dark .dashbored-wrap .card,
body.theme-dark .dashbored-wrap .mat-mdc-card,
body.theme-dark .dashbored-wrap .tile,
body.theme-dark .dashbored-wrap .com-record,
body.theme-dark .dashbored-wrap .table-wrap,
body.theme-dark .dashbored-wrap .detail-list,
body.theme-dark .dashbored-wrap .filter,
body.theme-dark .dashbored-wrap .search-input,
body.theme-dark .dashbored-wrap .tab-content,
body.theme-dark .dashbored-wrap .followers-tag .box {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap table,
body.theme-dark .dashbored-wrap thead,
body.theme-dark .dashbored-wrap tbody,
body.theme-dark .dashbored-wrap tr,
body.theme-dark .dashbored-wrap td {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap th {
  background: var(--fc-bg-head) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap tbody tr:hover {
  background: var(--fc-bg-hover) !important;
}

body.theme-dark .dashbored-wrap input,
body.theme-dark .dashbored-wrap select,
body.theme-dark .dashbored-wrap textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap .mobile-design {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .mobile-design .tile {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap [class*=skeleton-] {
  background: var(--fc-skel) !important;
  color: transparent !important;
}

body.theme-dark .dashbored-wrap p,
body.theme-dark .dashbored-wrap label,
body.theme-dark .dashbored-wrap li,
body.theme-dark .dashbored-wrap h1,
body.theme-dark .dashbored-wrap h2,
body.theme-dark .dashbored-wrap h3,
body.theme-dark .dashbored-wrap h4,
body.theme-dark .dashbored-wrap h5,
body.theme-dark .dashbored-wrap h6 {
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=status]) {
  color: var(--fc-fg) !important;
}

body.theme-dark .reviews-table {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .reviews-table td,
body.theme-dark .reviews-table th {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .stat-card {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .notes-textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .review-card {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

/* ── Direct body.theme-dark additions (flow-reviews page) ── */
/* Summary stat cards */
body.theme-dark .flow-reviews-stats.followers-tag .box {
  background: var(--fc-bg2) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .flow-reviews-stats.followers-tag .box .text .count {
  background: transparent !important;
  background-color: transparent !important;
}

body.theme-dark .flow-reviews-stats.followers-tag .box .text .count b {
  color: #f1f5f9 !important;
}

body.theme-dark .flow-reviews-stats.followers-tag .box .text p {
  color: #94a3b8 !important;
}

/* Flow analytics cards */
body.theme-dark .flow-analytics-card {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .flow-analytics-card .analytics-count-badge {
  background: #374151 !important;
  color: #94a3b8 !important;
}

/* Table action bar */
body.theme-dark .table-action-bar {
  background-color: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .table-action-bar .selected-count {
  color: var(--fc-fg) !important;
}

body.theme-dark .table-action-bar .btn-secondary {
  background-color: #374151 !important;
  color: #e5e7eb !important;
}

/* Modern review cards */
body.theme-dark .reviews-list-card .review-card-modern,
body.theme-dark .reviews-list .review-card-modern {
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .review-card-modern .reviewer-name-modern {
  color: #f1f5f9 !important;
}

body.theme-dark .review-card-modern .review-date-modern {
  color: #94a3b8 !important;
}

body.theme-dark .review-card-modern .review-text-modern p {
  color: #cbd5e1 !important;
}

body.theme-dark .review-card-modern .review-header-modern {
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .review-card-modern .review-issues-modern {
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .review-card-modern .issue-item-modern {
  background: #0f172a !important;
}

body.theme-dark .review-card-modern .issue-description-modern {
  color: #94a3b8 !important;
}

body.theme-dark .review-card-modern .issue-response-modern {
  background: rgba(59, 130, 246, 0.1) !important;
}

body.theme-dark .review-card-modern .review-response-section {
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .review-card-modern .review-response-modern {
  background: rgba(59, 130, 246, 0.1) !important;
}

body.theme-dark .review-card-modern .response-textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

/* Old review card */
body.theme-dark .reviews-list .review-card .review-header {
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .reviews-list .review-card .completion-status {
  background: #374151 !important;
}

body.theme-dark .reviews-list .review-card .review-text p {
  color: #cbd5e1 !important;
}

body.theme-dark .reviews-list .review-card .issue-item {
  background: #0f172a !important;
}

body.theme-dark .reviews-list .review-card .issue-response,
body.theme-dark .reviews-list .review-card .review-response {
  background: rgba(59, 130, 246, 0.1) !important;
}

/* Review details modal */
body.theme-dark .review-details-modal {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .review-details-modal .modal-header-new {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .review-details-modal .modal-right-column {
  background-color: #0f172a !important;
}

body.theme-dark .review-details-modal .modal-footer-new {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .review-details-modal .rating-status-section {
  background-color: #374151 !important;
}

body.theme-dark .review-details-modal .header-user-name {
  color: #f1f5f9 !important;
}

body.theme-dark .review-details-modal .header-flow-name {
  color: #94a3b8 !important;
}

body.theme-dark .review-details-modal .review-title-modal {
  color: #f1f5f9 !important;
}

body.theme-dark .review-details-modal .review-text-modal {
  color: #cbd5e1 !important;
}

body.theme-dark .review-details-modal .review-date-modal {
  color: #94a3b8 !important;
}

body.theme-dark .review-details-modal .section-title {
  color: #64748b !important;
}

body.theme-dark .review-details-modal .notes-textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .review-details-modal .response-textarea-new {
  background-color: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .review-details-modal .response-label {
  color: #64748b !important;
}

body.theme-dark .review-details-modal .flag-btn {
  background-color: #374151 !important;
  color: #e5e7eb !important;
}

/* Skeleton containers */
body.theme-dark .skeleton-box {
  background: var(--fc-bg2) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .skeleton-tile,
body.theme-dark .skeleton-table-container,
body.theme-dark .skeleton-mobile-container {
  background: var(--fc-bg2) !important;
}

/* ── Override global white-background globals (.table-card, .fc-table, .big-box, .filter-section) ── */
body.theme-dark .table-card {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
}

body.theme-dark .big-box {
  background: #111827 !important;
  background-color: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .fc-table {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .fc-table thead th {
  background-color: #0f172a !important;
  background: #0f172a !important;
  color: #94a3b8 !important;
  border-bottom-color: rgba(148, 163, 184, 0.25) !important;
  border-right-color: rgba(148, 163, 184, 0.15) !important;
}

body.theme-dark .fc-table tbody td {
  background-color: #1f2937 !important;
  color: #e2e8f0 !important;
  border-top-color: rgba(148, 163, 184, 0.15) !important;
  border-right-color: rgba(148, 163, 184, 0.1) !important;
}

body.theme-dark .fc-table tbody tr:nth-child(even) td {
  background-color: #253347 !important;
}

body.theme-dark .fc-table tbody tr:hover td {
  background-color: #374151 !important;
  color: #f1f5f9 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

body.theme-dark .filter-section {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .filter-section label {
  color: #94a3b8 !important;
}

body.theme-dark .filter-section select,
body.theme-dark .filter-section input {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

/* ── Stat card count white-bg fix (highest specificity override) ── */
body.theme-dark .com-record .followers-tag .box {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .com-record .followers-tag .box .text .count {
  background: transparent !important;
  background-color: transparent !important;
}

body.theme-dark .com-record .followers-tag .box .text .count b {
  color: #f1f5f9 !important;
}

body.theme-dark .com-record .followers-tag .box .text p {
  color: #94a3b8 !important;
}

body.theme-dark .com-record .followers-tag .box .card-icon {
  color: #5ea1d8 !important;
}

/* ── Dark scrollbars and overflow area fix ── */
body.theme-dark .table-parent {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .table-parent::-webkit-scrollbar,
body.theme-dark .table-card::-webkit-scrollbar {
  background: #111827;
  width: 6px;
  height: 6px;
}

body.theme-dark .table-parent::-webkit-scrollbar-track,
body.theme-dark .table-card::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb,
body.theme-dark .table-card::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,
body.theme-dark .table-card::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

body.theme-dark .table-parent::-webkit-scrollbar-corner,
body.theme-dark .table-card::-webkit-scrollbar-corner {
  background: #111827;
}

/* ── Status badge dark mode overrides (table view) ── */
body.theme-dark .status-badge.completed {
  background-color: #052e16 !important;
  color: #86efac !important;
}

body.theme-dark .status-badge.failed {
  background-color: #450a0a !important;
  color: #fca5a5 !important;
}

/* ── Status badge dark mode overrides (card view) ── */
body.theme-dark .status-badge-modern.completed {
  background-color: #052e16 !important;
  color: #86efac !important;
}

body.theme-dark .status-badge-modern.failed {
  background-color: #450a0a !important;
  color: #fca5a5 !important;
}

/* ── Analytics count badge ── */
body.theme-dark .analytics-count-badge {
  background: #374151 !important;
  color: #94a3b8 !important;
}

/* ── Custom flow-name search dropdown panel ── */
body.theme-dark .flow-filter-dropdown-panel {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;
}

body.theme-dark .flow-dropdown-option {
  background: #0f172a !important;
  color: #e2e8f0 !important;
}

body.theme-dark .flow-dropdown-option:hover {
  background-color: rgba(148, 163, 184, 0.12) !important;
}

body.theme-dark .flow-dropdown-option.selected {
  background-color: rgba(94, 161, 216, 0.18) !important;
  color: #93c5fd !important;
}

/* ── Star rating: keep golden in dark mode ── */
body.theme-dark .rating-cell .star-icon,
body.theme-dark .star-icon-modal.filled,
body.theme-dark .star-icon-modal.half,
body.theme-dark .star-icon-modern.filled,
body.theme-dark .star-icon-modern.half {
  color: #ffc107 !important;
}

body.theme-dark .star-icon-modal:not(.filled):not(.half),
body.theme-dark .star-icon-modern:not(.filled):not(.half) {
  color: #4b5563 !important;
}

body.theme-dark .flow-dropdown-empty {
  color: #94a3b8 !important;
}

/* Native select / status filter */
body.theme-dark .status-filter,
body.theme-dark .filters-section .status-filter {
  background: #0f172a !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

/* ── Modal status badge dark mode (flow details modal header) ── */
body.theme-dark .status-badge-modal {
  background: #1e3a5f !important;
  color: #93c5fd !important;
}

body.theme-dark .status-badge-modal.completed {
  background: #052e16 !important;
  color: #86efac !important;
}

body.theme-dark .status-badge-modal.failed {
  background: #450a0a !important;
  color: #fca5a5 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/flow-reviews/flow-reviews.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,6EAAA;AACA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EAEA,8BAAA;AACF;AACE;EACE,mBAAA;EACA,YAAA;EACA,SAAA;AACJ;AAEE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;AAAJ;;AAIA;EACE,eAAA;EACA,aAAA;AADF;AAGE;EACE,yBAAA;EACA,WAAA;EACA,OAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,gBAAA;EACA,iCAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAJF;AAME;EACE,oBAAA;AAJJ;;AAQA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iBAAA;AALF;;AAQA,6DAAA;AACA;EACE,mBAAA;EACA,WAAA;EAkFA,+BAAA;AAtFF;AAME;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAJJ;AAOE;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,SAAA;EACA,gBAAA;EACA,qDAAA;AANJ;AASE;EACE,2BAAA;EACA,2CAAA;AAPJ;AAUE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;AATJ;AAYE;EACE,eAAA;EACA,cAAA;AAVJ;AAaE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,QAAA;AAXJ;AAcE;EACE,4BAAA;EACA,2BAAA;AAZJ;AAeE;EACE,eAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAbJ;AAgBE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAdJ;AAkBE;EACE,gBAAA;AAhBJ;AAmBE;EACE,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAlBJ;AAqBE;EACE,YAAA;EACA,eAAA;AAnBJ;AAsBE;EACE;IACE,eAAA;IACA,WAAA;EApBJ;AACF;;AAwBA;EACE;IAAK,2BAAA;EApBL;EAqBA;IAAO,4BAAA;EAlBP;AACF;AAoBA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAlBF;AAoBE;EACE,mBAAA;EACA,cAAA;AAlBJ;AAqBE;EACE,mBAAA;EACA,cAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AApBF;AAsBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AApBJ;AAsBI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AApBN;AAwBE;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAtBN;AAwBM;EACE,WAAA;EAUA,wEAAA;AA/BR;AAuBQ;EACE,WAAA;AArBV;AAwBQ;EACE,WAAA;AAtBV;AA0BQ;EACE,aAAA;AAxBV;AA2BQ;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAzBV;AA4BQ;EACE,SAAA;AA1BV;AA6BQ;EACE,sHAAA;EACA,oDAAA;AA3BV;AA+BM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,cAAA;AA7BR;AAgCM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,SAAA;EACA,uCAAA;AA9BR;AAgCQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA9BV;AAiCQ;EACE,yBAAA;AA/BV;AAkCQ;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAhCV;AAoCM;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAlCR;AAsCE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AApCJ;AAsCI;EACI,cAAA;EACA,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AApCR;AAsCQ;EACE,oDAAA;AApCV;AAuCQ;EACE,wBAAA;AArCV;;AA2CA;EACE,UAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;AAxCF;AA0CE;EACE,mBAAA;AAxCJ;AA0CI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAxCN;AA0CM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAxCR;AA2CM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAzCR;AA6CI;EACE,gBAAA;EACA,kBAAA;AA3CN;AA6CM;EACE,gBAAA;AA3CR;AA+CI;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AA7CN;AAgDI;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AA9CN;AAgDM;EACE,mBAAA;AA9CR;AAgDQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AA9CV;AAgDU;EACE,0BAAA;AA9CZ;AAqDE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAnDJ;AAqDI;EACE,gBAAA;EACA,WAAA;AAnDN;AAuDE;EACE,kBAAA;EACA,kBAAA;AArDJ;AAuDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AArDN;AAwDI;EACE,iBAAA;EACA,WAAA;AAtDN;AAyDI;EACE,SAAA;EACA,WAAA;AAvDN;AA4DE;EACE,WAAA;AA1DJ;AA4DI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;AA1DN;AA4DM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA1DR;AA4DQ;EACE,gBAAA;EACA,WAAA;AA1DV;AA8DM;EACE,aAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AA5DR;AA8DQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AA5DV;AA8DU;EACE,yBAAA;EACA,YAAA;AA5DZ;AA+DU;EACE,yBAAA;EACA,WAAA;AA7DZ;AAgEU;EACE,yBAAA;EACA,YAAA;AA9DZ;AAiEU;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/DZ;AAqEI;EACE,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAnEN;AAqEM;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,gCAAA;AAnER;AAsEM;EACE,aAAA;EACA,gCAAA;EACA,sBAAA;AApER;AAuEM;EACE,eAAA;EACA,iCAAA;AArER;AAuEQ;EACE,yBAAA;AArEV;AAwEQ;EACE,mBAAA;AAtEV;AA0EU;EACE,yBAAA;AAxEZ;AA6EM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA3ER;AA6EQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA3EV;AA6EU;EACE,iBAAA;EACA,YAAA;EACA,UAAA;AA3EZ;AA+EQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA7EV;AA+EU;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7EZ;AAgFU;EACE,eAAA;EACA,WAAA;AA9EZ;AAmFM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAjFR;AAmFQ;EACE,0BAAA;AAjFV;AAqFM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAnFR;AAqFQ;EACE,yBAAA;EACA,cAAA;AAnFV;AAsFQ;EACE,yBAAA;EACA,cAAA;AApFV;AAuFQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArFV;AAyFM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAvFR;AA0FM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAxFR;AA0FQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAxFV;AA6FQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA3FV;AA6FU;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3FZ;AA+FQ;EACE,WAAA;AA7FV;AAkGQ;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAhGV;AAkGU;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAhGZ;AAmGU;EACE,yCAAA;AAjGZ;AAqGQ;EACE,WAAA;AAnGV;AA0GE;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AAxGJ;AA0GI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAxGN;AA0GM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAxGR;AA0GQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;AAxGV;AA0GU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yCAAA;AAxGZ;AA0GY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAxGd;AA6GY;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA3Gd;AA8GY;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AA5Gd;AA8Gc;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AA5GhB;AA8GgB;EACE,0BAAA;AA5GlB;AAmHQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAjHV;AAmHU;EACE,WAAA;AAjHZ;AAoHU;EACE,yBAAA;AAlHZ;AAuHM;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;AArHR;AAuHQ;EACE,UAAA;AArHV;AAwHQ;EACE,uBAAA;AAtHV;AAyHQ;EACE,mBAAA;EACA,mBAAA;AAvHV;AAyHU;EACE,mBAAA;AAvHZ;AA2HU;EACE,aAAA;EACA,0BAAA;EACA,gBAAA;AAzHZ;AA2HY;EALF;IAMI,0BAAA;IACA,gBAAA;EAxHZ;AACF;AA0HY;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAxHd;AA0Hc;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAxHhB;AA0HgB;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxHlB;AA0HkB;EACE,aAAA;EACA,QAAA;AAxHpB;AA0HoB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAxHtB;AA0HsB;EACE,cAAA;AAxHxB;AA2HsB;EACE,cAAA;AAzHxB;AA8HkB;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AA5HpB;AAgIgB;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA9HlB;AAgIkB;EACE,yBAAA;EACA,cAAA;AA9HpB;AAiIkB;EACE,yBAAA;EACA,cAAA;AA/HpB;AAqIc;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAnIhB;AAsIc;EACE,SAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AApIhB;AAyIc;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAvIhB;AA0Ic;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAxIhB;AA0IgB;EALF;IAMI,8BAAA;EAvIhB;AACF;AAyIgB;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,qDAAA;AAvIlB;AAyIkB;EACE,2BAAA;EACA,yCAAA;AAvIpB;AA0IkB;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAxIpB;AA2IkB;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAzIpB;AA2IoB;EACE,UAAA;AAzItB;AA4IoB;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yCAAA;AA1ItB;AA8IkB;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA5IpB;AAmJU;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjJZ;AAmJY;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAjJd;AAmJc;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAjJhB;AAsJc;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AApJhB;AAsJgB;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AApJlB;AAsJkB;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AApJpB;AAuJkB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AArJpB;AAwJkB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAtJpB;AA2Jc;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAzJhB;AA2JgB;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;AAzJlB;AA6Jc;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AA3JhB;AAgKc;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA9JhB;AAgKgB;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,0CAAA;AA9JlB;AAgKkB;EACE,qCAAA;EACA,0CAAA;AA9JpB;AAiKkB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA/JpB;AAkKkB;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAhKpB;AAkKoB;EACE,cAAA;AAhKtB;AAwKc;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AAtKhB;AAwKgB;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAtKlB;AAyKgB;EACE,cAAA;AAvKlB;AA2Kc;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAzKhB;AAgLM;EACE,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA9KR;AAiLU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AA/KZ;AAkLU;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AAhLZ;AAkLY;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhLd;AAmLY;EACE,cAAA;AAjLd;AAsLQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;AApLV;AAsLU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AApLZ;AAsLY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApLd;AAwLU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;AAtLZ;AAwLY;;EAEE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,8BAAA;AAtLd;AAwLc;;EACE,8BAAA;AArLhB;AAyLY;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAvLd;AAyLc;EACE,yBAAA;AAvLhB;AA0Lc;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxLhB;AA4LY;EACE,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6DAAA;EACA,+BAAA;EACA,8BAAA;EACA,yBAAA;AA1Ld;AA4Lc;EACE,oCAAA;EACA,6DAAA;AA1LhB;AAmME;EACE,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAjMJ;AAmMI;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AAjMN;AAmMM;EACE,6CAAA;AAjMR;AAoMM;EACE,aAAA;AAlMR;AAqMM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAnMR;AAqMQ;EANF;IAOI,mBAAA;IACA,8BAAA;IACA,uBAAA;EAlMR;AACF;AAoMQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAlMV;AAoMU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAlMZ;AAoMY;EACE,iBAAA;EACA,YAAA;EACA,UAAA;AAlMd;AAsMU;EACE,aAAA;EACA,sBAAA;AApMZ;AAsMY;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AApMd;AAuMY;EACE,eAAA;EACA,cAAA;AArMd;AA0MQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAxMV;AA0MU;EACE,0BAAA;AAxMZ;AA2MU;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzMZ;AA8MM;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA5MR;AA8MQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AA5MV;AA8MU;EACE,yBAAA;EACA,yBAAA;AA5MZ;AA+MU;EACE,yBAAA;EACA,yBAAA;AA7MZ;AAgNU;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9MZ;AAkNM;EACE,aAAA;EACA,QAAA;AAhNR;AAkNQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhNV;AAkNU;EACE,cAAA;AAhNZ;AAmNU;EACE,cAAA;AAjNZ;AAuNM;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AArNR;AAuNQ;EANF;IAOI,gCAAA;EApNR;AACF;AAuNU;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AArNZ;AA0NU;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;AAxNZ;AA0NY;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;AAxNd;AA2NY;EACE,sBAAA;AAzNd;AA4NY;EACE,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;AA1Nd;AA4Nc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA1NhB;AA8NY;EACE,UAAA;AA5Nd;AA+NY;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,0CAAA;EACA,UAAA;AA7Nd;AA+Nc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA7NhB;AAgOc;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AA9NhB;AAmOc;EACE,UAAA;AAjOhB;AAoOc;EACE,UAAA;AAlOhB;AAuOc;EACE,YAAA;AArOhB;AA4OM;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA1OR;AA4OQ;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA1OV;AA6OQ;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,8BAAA;AA3OV;AA6OU;EACE,kBAAA;AA3OZ;AA6OY;EACE,cAAA;AA3Od;AA+OU;EACE,aAAA;EACA,cAAA;EACA,gBAAA;AA7OZ;AAgPU;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AA9OZ;AAgPY;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;AA9Od;AAkPU;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAhPZ;AAkPY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAhPd;AAkPc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhPhB;AAmPc;EACE,cAAA;AAjPhB;AAoPc;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAlPhB;AAsPY;EACE,SAAA;EACA,cAAA;AApPd;AAwPU;EACE,gBAAA;AAtPZ;AAwPY;EACE,WAAA;EACA,kBAAA;AAtPd;AAyPY;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EACA,oCAAA;EACA,uBAAA;EACA,6DAAA;EACA,+BAAA;EACA,8BAAA;AAvPd;AAyPc;EACE,8BAAA;AAvPhB;AA0Pc;EACE,oCAAA;EACA,oDAAA;EACA,iCAAA;AAxPhB;AA+PM;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA7PR;AA+PQ;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AA7PV;AA+PU;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA7PZ;AAgQU;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA9PZ;AAkQQ;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAhQV;AAkQU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAhQZ;AAkQY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhQd;AAmQY;EACE,cAAA;AAjQd;AAoQY;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAlQd;AAsQU;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AApQZ;AAyQU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAvQZ;AA0QU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AAxQZ;AA0QY;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAxQd;AA2QY;EACE,cAAA;AAzQd;AA6QU;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;AA3QZ;AA6QY;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EACA,oCAAA;EACA,uBAAA;EACA,6DAAA;EACA,+BAAA;AA3Qd;AA6Qc;EACE,oCAAA;EACA,oDAAA;EACA,iCAAA;AA3QhB;AAoRE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlRJ;AAoRM;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AAlRN;AAoRM;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,SAAA;EACA,YAAA;AAlRR;AAoRQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;AAlRV;AAoRU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAlRZ;AAqRU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAnRZ;AAsRU;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;AApRZ;AAsRY;EACE,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AApRd;AAuRY;EACE,eAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;AArRd;AA0RQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;AAxRV;AA0RU;EACE,0BAAA;AAxRZ;AA2RU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAzRZ;AA4RU;EACE,qBAAA;EACA,yBAAA;EACA,YAAA;AA1RZ;AAgSQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AA9RV;AAiSY;EACE,cAAA;AA/Rd;AAkSY;EACE,cAAA;AAhSd;AAoSU;EACE,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAlSZ;AAsSQ;EACE,mBAAA;EACA,qBAAA;EACA,yBAAA;AApSV;AAsSU;EACE,SAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AApSZ;AAwSQ;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AAtSV;AAwSU;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;AAtSZ;AA0SQ;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AAxSV;AA0SU;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AAxSZ;AA2SY;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AAzSZ;AA2SY;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;AAzSd;AA2Sc;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAzShB;AA6SY;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AA3Sd;AA8SY;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AA5Sd;AA8Sc;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;AA5ShB;AAgTY;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AA9Sd;AAgTc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA9ShB;AAgTgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA9SlB;AAiTgB;EACE,WAAA;AA/SlB;AAkTgB;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAhTlB;AAoTc;EACE,SAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAlThB;AAsTY;EACE,gBAAA;AApTd;AAsTc;EACE,WAAA;EACA,kBAAA;AApThB;AAsTgB;EACE,WAAA;AApTlB;AAuTgB;EACE,WAAA;AArTlB;AAyTc;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oCAAA;EACA,wBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,6BAAA;EACA,0BAAA;AAvThB;AAyTgB;;EAEE,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,6BAAA;EACA,gCAAA;EACA,2BAAA;AAvTlB;AA0TgB;EACE,oCAAA;AAxTlB;AA2TgB;EACE,oCAAA;AAzTlB;AAgUQ;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AA9TV;AAgUU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA9TZ;AAgUY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA9Td;AAiUY;EACE,WAAA;AA/Td;AAkUY;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAhUd;AAoUU;EACE,SAAA;EACA,WAAA;AAlUZ;AAsUQ;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AApUV;AAsUU;EACE,WAAA;EACA,mBAAA;AApUZ;AAsUY;EACE,WAAA;AApUd;AAuUY;EACE,WAAA;AArUd;AAyUU;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oCAAA;EACA,wBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,6BAAA;EACA,0BAAA;AAvUZ;AAyUY;;EAEE,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,6BAAA;EACA,gCAAA;EACA,2BAAA;AAvUd;AA0UY;EACE,oCAAA;AAxUd;AA2UY;EACE,oCAAA;AAzUd;;AAkVA;EAGI;IACE,WAAA;IACA,OAAA;IACA,kBAAA;EAjVJ;EAqVA;IACE,UAAA;EAnVF;EAsVA;IACE,uBAAA;EApVF;EAuVA,yDAAA;EACA;;IAEE,sBAAA;IACA,0BAAA;IACA,sBAAA;EArVF;EAuVA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;IACA,mBAAA;IACA,eAAA;EArVF;EAuVA;;IAEE,yBAAA;IACA,uBAAA;IACA,0BAAA;IACA,sBAAA;EArVF;EAuVA;;;IAGE,sBAAA;IACA,0BAAA;EArVF;EAwVA;IACE,UAAA;IAEA,4EAAA;EAvVF;EAwVE;IACE,WAAA;IACA,eAAA;IACA,sBAAA;EAtVJ;EAwVE;IACE,wBAAA;IACA,qCAAA;IACA,SAAA;IACA,WAAA;IACA,eAAA;IACA,sBAAA;EAtVJ;EAwVE;IACE,WAAA;IACA,eAAA;IACA,sBAAA;IACA,uBAAA;IACA,gBAAA;EAtVJ;EAwVE;IACE,sBAAA;IACA,cAAA;EAtVJ;EAwVE;;;IAGE,yBAAA;IACA,sBAAA;IACA,0BAAA;IACA,sBAAA;EAtVJ;EAwVE;IACE,0BAAA;IACA,uBAAA;EAtVJ;EA0VE;IACE,gBAAA;EAxVJ;EA0VI;IACE,sBAAA;IACA,SAAA;IACA,uBAAA;EAxVN;EA0VM;IACE,eAAA;EAxVR;EA4VI;IACE,gBAAA;EA1VN;EA8VE;IACE,gBAAA;EA5VJ;EA8VI;IACE,mBAAA;IACA,aAAA;EA5VN;EA8VM;IACE,sBAAA;IACA,SAAA;EA5VR;EAiWM;IACE,sBAAA;IACA,SAAA;EA/VR;EAiWQ;IACE,sBAAA;EA/VV;EAqWE;IACE,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;IACA,uBAAA;IACA,uBAAA;EAnWJ;EAqWI;IACE,gBAAA;IACA,6BAAA;IACA,WAAA;IACA,mBAAA;IACA,WAAA;EAnWN;EAqWM;IACE,aAAA;EAnWR;EAsWU;IACE,eAAA;IACA,mBAAA;EApWZ;EAuWU;IACE,eAAA;EArWZ;EAyWQ;IACE,QAAA;IACA,UAAA;EAvWV;EA6WU;IACE,aAAA;EA3WZ;EAgXM;IACE,aAAA;EA9WR;AACF;AAoXA,8DAAA;AACA,+EAAA;AACA;;EAGE,wBAAA;EACA,uCAAA;EACA,2BAAA;EACA,6BAAA;EACA,8CAAA;EACA,sBAAA;AAnXF;;AAsXA,gFAAA;AACA;;EAEE,2BAAA;EACA,kCAAA;EACA,8BAAA;EACA,yBAAA;AAnXF;;AA4XE;;;;;;;;;;;EAWE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAzXJ;AA6XE;EACE,8BAAA;EACA,kDAAA;AA3XJ;AA4XI;EAA8B,iDAAA;AAzXlC;AA0XI;EAAmB,yBAAA;AAvXvB;AAwXI;EAA2G,yBAAA;AArX/G;AAyXE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAvXJ;AAyXE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAvXJ;AAyXE;EAAiB,8BAAA;AAtXnB;AAwXE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AAtXJ;AAyXE;EACE,yBAAA;AAvXJ;AA0XE;EACE,8BAAA;AAxXJ;AAyXI;EAAQ,8BAAA;EAAgC,kDAAA;AArX5C;AAyXE;EAAiB,oFAAA;EAAsF,qCAAA;AArXzG;AAwXE;EACE,8BAAA;EACA,kDAAA;AAtXJ;AAuXI;EAAwB,iDAAA;AApX5B;AAqXI;EAAoB,yBAAA;AAlXxB;AAmXI;EAAwB,yBAAA;AAhX5B;AAiXI;EAAsB,yBAAA;AA9W1B;AA+WI;EAAyB,yBAAA;AA5W7B;AAgXE;EAA0B,yCAAA;AA7W5B;AA8WE;EACE,8BAAA;EACA,kDAAA;AA5WJ;AA6WI;EAAoB,8BAAA;EAAgC,iDAAA;AAzWxD;AA0WI;EAAoB,yBAAA;AAvWxB;AAwWI;EAAoB,yBAAA;AArWxB;AAsWI;EAAkB,8BAAA;AAnWtB;AAoWI;EAAoB,8BAAA;EAAgC,iDAAA;AAhWxD;AAiWI;EACE,8BAAA;AA/VN;AAgWM;EAA8B,yBAAA;AA7VpC;AA8VM;EAA4B,yBAAA;AA3VlC;AAgWE;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA9VJ;AAkWE;EACE,8BAAA;EACA,kDAAA;EACA,oDAAA;AAhWJ;AAmWE;EACE,8BAAA;EACA,yBAAA;AAjWJ;AAmWI;EACE,yBAAA;AAjWN;AAoWI;EACE,sDAAA;AAlWN;AAqWI;EACE,qDAAA;EACA,yBAAA;AAnWN;AAuWE;EACE,yBAAA;AArWJ;;AA+WA;;EAEE,mCAAA;EACA,8BAAA;AA5WF;;AA+WA;;;;;;;;;;;;EAYE,oCAAA;EACA,8BAAA;EACA,yCAAA;AA5WF;;AA+WA;;;;;EAKE,mCAAA;EACA,8BAAA;EACA,yCAAA;AA5WF;;AA+WA;EACE,wCAAA;EACA,8BAAA;EACA,yCAAA;AA5WF;;AA+WA;EACE,yCAAA;AA5WF;;AA+WA;;;EAGE,8BAAA;EACA,8BAAA;EACA,yCAAA;AA5WF;;AA+WA;EACE,mCAAA;EACA,8BAAA;AA5WF;;AA+WA;EACE,oCAAA;EACA,8BAAA;EACA,yCAAA;AA5WF;;AA+WA;EACE,qCAAA;EACA,6BAAA;AA5WF;;AA+WA;;;;;;;;;EASE,8BAAA;AA5WF;;AA+WA;EACE,8BAAA;AA5WF;;AA8WA;EACE,mCAAA;EACA,8BAAA;EACA,yCAAA;AA3WF;;AA6WA;;EAEE,mCAAA;EACA,8BAAA;EACA,yCAAA;AA1WF;;AA4WA;EACE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAzWF;;AA2WA;EACE,8BAAA;EACA,8BAAA;EACA,yCAAA;AAxWF;;AA0WA;EACE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAvWF;;AA0WA,+DAAA;AAEA,uBAAA;AACA;EACE,oCAAA;EACA,yCAAA;AAxWF;;AA2WA;EACE,kCAAA;EACA,wCAAA;AAxWF;;AA2WA;EAAwE,yBAAA;AAvWxE;;AAwWA;EAAiE,yBAAA;AApWjE;;AAsWA,yBAAA;AACA;EACE,8BAAA;EACA,iDAAA;AAnWF;;AAsWA;EACE,8BAAA;EACA,yBAAA;AAnWF;;AAsWA,qBAAA;AACA;EACE,0CAAA;EACA,8BAAA;AAnWF;;AAsWA;EAAoD,8BAAA;AAlWpD;;AAoWA;EACE,oCAAA;EACA,yBAAA;AAjWF;;AAoWA,wBAAA;AACA;;EAEE,oCAAA;EACA,iDAAA;AAjWF;;AAoWA;EAA4D,yBAAA;AAhW5D;;AAiWA;EAA0D,yBAAA;AA7V1D;;AA8VA;EAA4D,yBAAA;AA1V5D;;AA2VA;EAA4D,iDAAA;AAvV5D;;AAyVA;EAA4D,iDAAA;AArV5D;;AAsVA;EACE,8BAAA;AAnVF;;AAsVA;EAAgE,yBAAA;AAlVhE;;AAmVA;EAA6D,8CAAA;AA/U7D;;AAiVA;EAA+D,iDAAA;AA7U/D;;AA8UA;EAA8D,8CAAA;AA1U9D;;AA2UA;EAAyD,8BAAA;EAAgC,8BAAA;EAAgC,yCAAA;AArUzH;;AAuUA,oBAAA;AACA;EAA4D,iDAAA;AAnU5D;;AAoUA;EAAgE,8BAAA;AAhUhE;;AAiUA;EAA4D,yBAAA;AA7T5D;;AA8TA;EAAyD,8BAAA;AA1TzD;;AA2TA;;EAC8D,8CAAA;AAvT9D;;AAyTA,yBAAA;AACA;EACE,8BAAA;EACA,iDAAA;AAtTF;;AAyTA;EACE,8BAAA;EACA,iDAAA;AAtTF;;AAyTA;EACE,oCAAA;AAtTF;;AAyTA;EACE,8BAAA;EACA,iDAAA;AAtTF;;AAyTA;EACE,oCAAA;AAtTF;;AAyTA;EAA0D,yBAAA;AArT1D;;AAsTA;EAA0D,yBAAA;AAlT1D;;AAmTA;EAA4D,yBAAA;AA/S5D;;AAgTA;EAA2D,yBAAA;AA5S3D;;AA6SA;EAA2D,yBAAA;AAzS3D;;AA0SA;EAAuD,yBAAA;AAtSvD;;AAuSA;EACE,8BAAA;EACA,8BAAA;EACA,yCAAA;AApSF;;AAuSA;EACE,oCAAA;EACA,8BAAA;EACA,yCAAA;AApSF;;AAuSA;EAAwD,yBAAA;AAnSxD;;AAqSA;EACE,oCAAA;EACA,yBAAA;AAlSF;;AAqSA,wBAAA;AACA;EACE,oCAAA;EACA,yCAAA;AAlSF;;AAqSA;;;EAGE,oCAAA;AAlSF;;AAoSA,uGAAA;AACA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;EACA,oDAAA;AAjSF;;AAmSA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AAhSF;;AAkSA;EACE,8BAAA;EACA,oCAAA;AA/RF;;AAiSA;EACE,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,yDAAA;EACA,wDAAA;AA9RF;;AAgSA;EACE,oCAAA;EACA,yBAAA;EACA,sDAAA;EACA,uDAAA;AA7RF;;AA+RA;EACE,oCAAA;AA5RF;;AA8RA;EACE,oCAAA;EACA,yBAAA;EACA,iDAAA;AA3RF;;AA6RA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AA1RF;;AA4RA;EACE,yBAAA;AAzRF;;AA2RA;;EAEE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,iDAAA;AAxRF;;AA2RA,sEAAA;AACA;EACE,8BAAA;EACA,oCAAA;EACA,iDAAA;AAxRF;;AA0RA;EACE,kCAAA;EACA,wCAAA;AAvRF;;AAyRA;EACE,yBAAA;AAtRF;;AAwRA;EACE,yBAAA;AArRF;;AAuRA;EACE,yBAAA;AApRF;;AAuRA,gDAAA;AACA;EACE,8BAAA;EACA,oCAAA;AApRF;;AAsRA;;EAEE,mBAAA;EACA,UAAA;EACA,WAAA;AAnRF;;AAqRA;;EAEE,mBAAA;EACA,kBAAA;AAlRF;;AAoRA;;EAEE,mBAAA;EACA,kBAAA;AAjRF;;AAmRA;;EAEE,mBAAA;AAhRF;;AAkRA;;EAEE,mBAAA;AA/QF;;AAkRA,wDAAA;AACA;EACE,oCAAA;EACA,yBAAA;AA/QF;;AAiRA;EACE,oCAAA;EACA,yBAAA;AA9QF;;AAiRA,uDAAA;AACA;EACE,oCAAA;EACA,yBAAA;AA9QF;;AAgRA;EACE,oCAAA;EACA,yBAAA;AA7QF;;AAgRA,gCAAA;AACA;EACE,8BAAA;EACA,yBAAA;AA7QF;;AAgRA,iDAAA;AACA;EACE,8BAAA;EACA,kDAAA;EACA,oDAAA;AA7QF;;AAgRA;EACE,8BAAA;EACA,yBAAA;AA7QF;;AAgRA;EACE,sDAAA;AA7QF;;AAgRA;EACE,qDAAA;EACA,yBAAA;AA7QF;;AAgRA,gDAAA;AACA;;;;;EAKE,yBAAA;AA7QF;;AAgRA;;EAEE,yBAAA;AA7QF;;AAgRA;EACE,yBAAA;AA7QF;;AAgRA,kCAAA;AACA;;EAEE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA7QF;;AAgRA,mEAAA;AACA;EACE,8BAAA;EACA,yBAAA;AA7QF;;AAgRA;EACE,8BAAA;EACA,yBAAA;AA7QF;;AAgRA;EACE,8BAAA;EACA,yBAAA;AA7QF","sourcesContent":["/* Match routed dashboard layout so content doesn't sit under the left menu */\n.setting-dashboard {\n  padding: 0;\n  height: auto;\n  position: relative;\n  // margin-top: 0;\n  background: var(--fc-bg, #fff);\n\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0;\n  }\n\n  .submission-field {\n    left: 16.666667%;\n    padding-right: 0;\n    position: absolute;\n    top: 0;\n    width: 83.333333%;\n    padding-left: 0;\n    border-left: 1px solid #fff;\n  }\n}\n\n.dashbored-wrap {\n  padding-left: 0;\n  margin-top: 0;\n\n  .table-wrap {\n    padding: 30px 30px 30px 0;\n    width: 100%;\n    left: 0;\n  }\n\n  .filter {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 0;\n    border: none;\n    padding: 0 0 16px;\n  }\n\n  .table-parent {\n    overflow-x: auto;\n    margin-top: -8px;\n  }\n}\n\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important;\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n\n  .dash-text {\n    padding: 10px 15px 0;\n  }\n}\n\n.com-record {\n  width: calc(100% - 250px);\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 0;\n  padding: 20px 30px 30px;\n  border: none !important;\n  box-shadow: none !important;\n  overflow: visible;\n}\n\n/* Summary cards at top (like Incoming Ownership dashboard) */\n.flow-reviews-stats {\n  margin-bottom: 24px;\n  width: 100%;\n\n  &.followers-tag {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    position: relative;\n    z-index: 1;\n  }\n\n  &.followers-tag .box {\n    padding: 5px 10px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    // box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.16);\n    gap: 12px;\n    min-width: 180px;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n  }\n\n  &.followers-tag .box:hover {\n    transform: translateY(-2px);\n    box-shadow: 2px 4px 30px rgba(0, 0, 0, 0.2);\n  }\n\n  &.followers-tag .box .icon {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &.followers-tag .box .ico-box {\n    width: 40px;\n    height: 40px;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  &.followers-tag .box .card-icon {\n    font-size: 24px;\n    color: #5ea1d8;\n  }\n\n  &.followers-tag .box .text {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    flex: 1;\n    justify-content: center;\n    gap: 2px;\n  }\n\n  &.followers-tag .box .text .count {\n    background: white !important;\n    box-shadow: none !important;\n  }\n\n  &.followers-tag .box .text .count b {\n    font-size: 24px;\n    font-weight: 700 !important;\n    color: #333;\n    display: block;\n    line-height: 1.2;\n  }\n\n  &.followers-tag .box .text p {\n    margin: 0;\n    font-size: 14px;\n    color: #666;\n    line-height: 1.2;\n    text-align: left;\n  }\n\n  /* Skeleton loading for cards */\n  &.skeleton-stats-container .box {\n    min-width: 180px;\n  }\n\n  .skeleton-text {\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: skeleton-shimmer 1.5s infinite;\n    border-radius: 4px;\n    height: 24px;\n    min-width: 60px;\n  }\n\n  .skeleton-box .ico-box.skeleton-text {\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n  }\n\n  .skeleton-box .text .skeleton-text {\n    height: 20px;\n    min-width: 80px;\n  }\n\n  @media (max-width: 768px) {\n    &.followers-tag .box {\n      min-width: 100%;\n      width: 100%;\n    }\n  }\n}\n\n@keyframes skeleton-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.moderation-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n\n  &.moderation-pending {\n    background: #fff3cd;\n    color: #856404;\n  }\n\n  &.moderation-resolved {\n    background: #d4edda;\n    color: #155724;\n  }\n}\n\n.filters-section {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: nowrap;\n  align-items: center;\n  overflow: visible;\n  width: 100%;\n\n  .flow-filter {\n    display: flex;\n    align-items: center;\n    align-self: center;\n    flex: 0 0 auto;\n    min-width: 180px;\n    max-width: 220px;\n\n    .status-filter {\n      width: 100%;\n      height: 40px;\n      box-sizing: border-box;\n      padding: 0 12px;\n      border-radius: 4px;\n      border: 1px solid #ddd;\n      background-color: #fff;\n      font-size: 14px;\n      font: inherit;\n      color: #333;\n    }\n  }\n\n  .search-and-flow-filter {\n      position: relative;\n      flex: 1 1 auto;\n      min-width: 240px;\n      max-width: 640px;\n      align-self: center;\n\n      .search-field {\n        width: 100%;\n\n        ::ng-deep .mat-mdc-form-field {\n          width: 100%;\n        }\n\n        ::ng-deep .mat-mdc-text-field-wrapper {\n          width: 100%;\n        }\n\n        /* Remove subscript gap so search lines up with status select + toggle */\n        ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n          display: none;\n        }\n\n        ::ng-deep .mat-mdc-form-field-infix {\n          min-height: 40px;\n          padding-top: 8px;\n          padding-bottom: 8px;\n        }\n\n        ::ng-deep .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {\n          top: 20px;\n        }\n\n        ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above {\n          --mat-mdc-form-field-label-transform: translateY(-26.75px) scale(var(--mat-mdc-form-field-floating-label-scale, 0.75));\n          transform: var(--mat-mdc-form-field-label-transform);\n        }\n      }\n\n      .flow-filter-dropdown-panel {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        right: 0;\n        margin-top: 4px;\n        max-height: 320px;\n        overflow-y: auto;\n        background: #fff;\n        border: 1px solid #e0e0e0;\n        border-radius: 8px;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n        z-index: 1000;\n        padding: 8px 0;\n      }\n\n      .flow-dropdown-option {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        padding: 10px 16px;\n        border: none;\n        background: none;\n        text-align: left;\n        font-size: 14px;\n        color: #333;\n        cursor: pointer;\n        font-family: inherit;\n        gap: 10px;\n        transition: background-color 0.15s ease;\n\n        .option-icon {\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n          color: #5ea1d8;\n        }\n\n        &:hover {\n          background-color: #f5f9ff;\n        }\n\n        &.selected {\n          background-color: #e8f4fd;\n          color: #1a67a8;\n          font-weight: 500;\n        }\n      }\n\n      .flow-dropdown-empty {\n        padding: 16px;\n        font-size: 13px;\n        color: #666;\n        text-align: center;\n      }\n    }\n\n  .view-toggle {\n    display: flex;\n    align-items: center;\n    align-self: center;\n    flex: 0 0 auto;\n    margin-left: auto;\n    height: 40px;\n\n    button {\n        color: #5ea1d8;\n        border: none !important;\n        box-shadow: none !important;\n        background: transparent !important;\n        padding: 0 !important;\n        width: 40px !important;\n        height: 40px !important;\n        min-width: 40px !important;\n        min-height: 40px !important;\n        border-radius: 50% !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n\n        &:hover {\n          background-color: rgba(94, 161, 216, 0.1) !important;\n        }\n\n        &:focus {\n          outline: none !important;\n        }\n      }\n    }\n}\n\n.flow-reviews-container {\n  padding: 0;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible;\n\n  .flow-analytics-section {\n    margin-bottom: 24px;\n\n    .flow-analytics-heading {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin: 0 0 16px 0;\n      font-size: 18px;\n      font-weight: 500;\n      color: #333;\n      flex-wrap: wrap;\n\n      .section-icon {\n        color: #5ea1d8;\n        font-size: 22px;\n        width: 22px;\n        height: 22px;\n      }\n\n      .analytics-count-badge {\n        font-size: 12px;\n        font-weight: 500;\n        color: #666;\n        background: #f0f0f0;\n        padding: 2px 8px;\n        border-radius: 12px;\n        margin-left: 4px;\n      }\n    }\n\n    .flow-analytics-show-more {\n      margin-top: 16px;\n      text-align: center;\n\n      button {\n        font-weight: 500;\n      }\n    }\n\n    .flow-analytics-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n      gap: 20px;\n    }\n\n    .flow-analytics-card {\n      background: #fafafa;\n      border: 1px solid #e8e8e8;\n      border-radius: 8px;\n      padding: 16px;\n      box-sizing: border-box;\n\n      .flow-analytics-card-header {\n        margin-bottom: 12px;\n\n        .flow-title-link {\n          font-size: 15px;\n          font-weight: 500;\n          color: #5ea1d8;\n          cursor: pointer;\n          text-decoration: none;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n  }\n\n  .loading-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 20px;\n\n    p {\n      margin-top: 16px;\n      color: #666;\n    }\n  }\n\n  .no-reviews {\n    text-align: center;\n    padding: 60px 20px;\n\n    mat-icon {\n      font-size: 64px;\n      width: 64px;\n      height: 64px;\n      color: #ccc;\n      margin-bottom: 16px;\n    }\n\n    h3 {\n      margin: 0 0 8px 0;\n      color: #666;\n    }\n\n    p {\n      margin: 0;\n      color: #999;\n    }\n  }\n\n  // Table View Styles\n  .table-view-container {\n    width: 100%;\n\n    .table-action-bar {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 12px 16px;\n      background-color: #f9f9f9;\n      border-radius: 8px 8px 0 0;\n      margin-bottom: 0;\n\n      .selection-info {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n\n        .selected-count {\n          font-weight: 500;\n          color: #333;\n        }\n      }\n\n      .table-actions {\n        display: flex;\n        gap: 8px;\n        flex-wrap: nowrap;\n        white-space: nowrap;\n\n        button {\n          display: inline-flex;\n          align-items: center;\n          gap: 6px;\n          padding: 8px 16px;\n          border-radius: 6px;\n          font-size: 14px;\n          text-transform: none;\n          white-space: nowrap;\n          flex-shrink: 0;\n\n          &.btn-primary {\n            background-color: #5ea1d8;\n            color: white;\n          }\n\n          &.btn-secondary {\n            background-color: #f3f4f6;\n            color: #333;\n          }\n\n          &.btn-delete {\n            background-color: #f44336;\n            color: white;\n          }\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n    }\n\n    .reviews-table {\n      width: 100%;\n      background: white;\n      border-radius: 0 0 8px 8px;\n      overflow: hidden;\n\n      th {\n        background-color: #f5f5f5;\n        font-weight: 600;\n        color: #333;\n        text-transform: uppercase;\n        font-size: 12px;\n        letter-spacing: 0.5px;\n        padding: 16px;\n        border-bottom: 2px solid #e0e0e0;\n      }\n\n      td {\n        padding: 16px;\n        border-bottom: 1px solid #e0e0e0;\n        vertical-align: middle;\n      }\n\n      tr {\n        cursor: pointer;\n        transition: background-color 0.2s;\n\n        &:hover {\n          background-color: #f9f9f9;\n        }\n\n        &:last-child td {\n          border-bottom: none;\n        }\n\n        &.table-row {\n          &:hover {\n            background-color: #f5f5f5;\n          }\n        }\n      }\n\n      .user-cell {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n\n        .user-avatar {\n          width: 40px;\n          height: 40px;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: white;\n          font-weight: 600;\n          font-size: 14px;\n          flex-shrink: 0;\n\n          &.user-avatar-img {\n            object-fit: cover;\n            border: none;\n            padding: 0;\n          }\n        }\n\n        .user-info {\n          display: flex;\n          flex-direction: column;\n          min-width: 0;\n\n          .user-name {\n            font-weight: 500;\n            color: #333;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n\n          .user-time {\n            font-size: 12px;\n            color: #999;\n          }\n        }\n      }\n\n      .flow-link-cell {\n        color: #5ea1d8;\n        text-decoration: none;\n        font-weight: 500;\n        cursor: pointer;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n\n      .status-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        padding: 6px 12px;\n        border-radius: 16px;\n        font-size: 12px;\n        font-weight: 600;\n        text-transform: uppercase;\n\n        &.completed {\n          background-color: #e8f5e9;\n          color: #4caf50;\n        }\n\n        &.failed {\n          background-color: #ffebee;\n          color: #f44336;\n        }\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n      }\n\n      .status-cell {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 6px;\n      }\n\n      .rating-cell {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        font-weight: 500;\n\n        .star-icon {\n          color: #ffc107;\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n\n      .snippet-cell {\n        .view-snippet-btn {\n          display: flex;\n          align-items: center;\n          gap: 6px;\n          color: #5ea1d8;\n          padding: 4px 8px;\n          min-width: auto;\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n          }\n        }\n\n        .no-snippet {\n          color: #999;\n        }\n      }\n\n      .media-cell {\n        .media-icon-btn {\n          min-width: auto;\n          padding: 4px;\n          color: #5ea1d8;\n\n          .media-icon {\n            color: #5ea1d8;\n            font-size: 20px;\n            width: 20px;\n            height: 20px;\n          }\n\n          &:hover {\n            background-color: rgba(94, 161, 216, 0.1);\n          }\n        }\n\n        .no-media {\n          color: #999;\n        }\n      }\n    }\n  }\n\n  // Review Details Modal - New Design\n  .review-details-overlay {\n    position: fixed;\n    top: var(--app-header, 56px);\n    left: 16.666667%; // Match submission-field left position\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000 !important; // Higher than dashboard sidebar menu (2001)\n    padding: 20px;\n\n    .review-details-modal {\n      background: white;\n      border-radius: 22px;\n      max-width: 900px;\n      width: 100%;\n      max-height: 90vh;\n      display: flex;\n      flex-direction: column;\n      box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n      border: none;\n      overflow: hidden;\n      position: relative;\n      z-index: 10001 !important;\n\n      .modal-header-new {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 20px 24px;\n        border-bottom: 1px solid #e0e0e0;\n        background: white;\n        position: sticky;\n        top: 0;\n        z-index: 20;\n\n        .header-user-info {\n          display: flex;\n          align-items: center;\n          gap: 16px;\n          flex: 1;\n\n          .header-avatar {\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            object-fit: cover;\n            border: 2px solid rgba(95, 162, 216, 0.2);\n\n            &.header-avatar-initials {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              color: white;\n              font-weight: 700;\n              font-size: 18px;\n              border: none;\n            }\n          }\n\n          .header-user-details {\n            .header-user-name {\n              margin: 0;\n              font-size: 20px;\n              font-weight: 600;\n              color: #212427;\n              line-height: 1.2;\n            }\n\n            .header-flow-name {\n              margin: 4px 0 0 0;\n              font-size: 13px;\n              color: #666;\n\n              .flow-name-link {\n                color: #5ea1d8;\n                font-weight: 500;\n                cursor: pointer;\n\n                &:hover {\n                  text-decoration: underline;\n                }\n              }\n            }\n          }\n        }\n\n        .close-btn-new {\n          position: absolute;\n          top: 12px;\n          right: 12px;\n          color: #666;\n\n          mat-icon {\n            color: #666;\n          }\n\n          &:hover {\n            background-color: #f1f5f9;\n          }\n        }\n      }\n\n      .modal-body-new {\n        flex: 1;\n        overflow-y: auto;\n        overflow-x: hidden;\n\n        &::-webkit-scrollbar {\n          width: 6px;\n        }\n\n        &::-webkit-scrollbar-track {\n          background: transparent;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: #cbd5e1;\n          border-radius: 10px;\n\n          &:hover {\n            background: #94a3b8;\n          }\n        }\n\n          .modal-grid {\n            display: grid;\n            grid-template-columns: 1fr;\n            border-top: none;\n\n            @media (min-width: 1024px) {\n              grid-template-columns: 1fr;\n              border-top: none;\n            }\n\n            .modal-left-column {\n              padding: 20px 24px;\n              border-right: none;\n              display: flex;\n              flex-direction: column;\n              gap: 20px;\n\n              .rating-status-section {\n                display: flex;\n                flex-wrap: wrap;\n                align-items: center;\n                justify-content: space-between;\n                gap: 12px;\n                padding: 12px 16px;\n                background-color: #f8f8f8;\n                border-radius: 12px;\n                margin-bottom: 4px;\n\n                .rating-date {\n                  display: flex;\n                  align-items: center;\n                  gap: 12px;\n\n                  .star-rating-modal {\n                    display: flex;\n                    gap: 2px;\n\n                    .star-icon-modal {\n                      font-size: 20px;\n                      width: 20px;\n                      height: 20px;\n                      color: #d1d5db;\n\n                      &.filled {\n                        color: #ffc107;\n                      }\n\n                      &.half {\n                        color: #ffc107;\n                      }\n                    }\n                  }\n\n                  .review-date-modal {\n                    font-size: 12px;\n                    font-weight: 500;\n                    color: #666;\n                  }\n                }\n\n                .status-badge-modal {\n                  padding: 4px 12px;\n                  border-radius: 999px;\n                  font-size: 11px;\n                  font-weight: 600;\n                  text-transform: uppercase;\n                  letter-spacing: 0.02em;\n                  background-color: #e3f2fd;\n                  color: #1565c0;\n\n                  &.completed {\n                    background-color: #c8e6c9;\n                    color: #1b5e20;\n                  }\n\n                  &.failed {\n                    background-color: #ffebee;\n                    color: #c62828;\n                  }\n                }\n              }\n\n            .review-text-section {\n              .review-title-modal {\n                margin: 0 0 8px 0;\n                font-size: 16px;\n                font-weight: 600;\n                color: #212427;\n                line-height: 1.4;\n              }\n\n              .review-text-modal {\n                margin: 0;\n                color: #666;\n                line-height: 1.6;\n                font-size: 14px;\n              }\n            }\n\n            .gallery-section {\n              .gallery-title {\n                font-size: 14px;\n                font-weight: 600;\n                color: #212427;\n                margin: 0 0 12px 0;\n              }\n\n              .gallery-grid {\n                display: grid;\n                grid-template-columns: 1fr;\n                gap: 12px;\n\n                @media (min-width: 640px) {\n                  grid-template-columns: 1fr 1fr;\n                }\n\n                .gallery-item {\n                  position: relative;\n                  aspect-ratio: 16 / 9;\n                  border-radius: 12px;\n                  overflow: hidden;\n                  background-color: #f8f8f8;\n                  border: 1px solid #e0e0e0;\n                  cursor: pointer;\n                  transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n                  &:hover {\n                    transform: translateY(-2px);\n                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n                  }\n\n                  .gallery-image {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                  }\n\n                  .gallery-video-overlay {\n                    position: relative;\n                    width: 100%;\n                    height: 100%;\n\n                    .gallery-image {\n                      opacity: 1;\n                    }\n\n                    .play-icon {\n                      position: absolute;\n                      top: 50%;\n                      left: 50%;\n                      transform: translate(-50%, -50%);\n                      font-size: 48px;\n                      width: 48px;\n                      height: 48px;\n                      color: white;\n                      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n                    }\n                  }\n\n                  .more-indicator {\n                    position: absolute;\n                    inset: 0;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    background-color: rgba(0, 0, 0, 0.5);\n                    color: white;\n                    font-weight: 700;\n                    font-size: 18px;\n                  }\n                }\n              }\n            }\n          }\n\n          .modal-right-column {\n            padding: 24px;\n            background-color: #f8fafc;\n            display: flex;\n            flex-direction: column;\n            gap: 32px;\n\n            .section-title {\n              font-size: 12px;\n              font-weight: 700;\n              text-transform: uppercase;\n              letter-spacing: 0.1em;\n              color: #94a3b8;\n              margin: 0;\n              display: flex;\n              align-items: center;\n              gap: 8px;\n\n              .section-icon {\n                font-size: 16px;\n                width: 16px;\n                height: 16px;\n              }\n            }\n\n            .stats-section {\n              .stats-grid {\n                display: grid;\n                grid-template-columns: 1fr 1fr;\n                gap: 16px;\n                margin-bottom: 16px;\n\n                .stat-card {\n                  padding: 12px;\n                  background: white;\n                  border-radius: 8px;\n                  border: 1px solid #e2e8f0;\n\n                  .stat-label {\n                    font-size: 10px;\n                    text-transform: uppercase;\n                    font-weight: 700;\n                    color: #64748b;\n                    margin: 0 0 4px 0;\n                  }\n\n                  .stat-value-primary {\n                    font-size: 20px;\n                    font-weight: 700;\n                    color: #5fa2d8;\n                    margin: 0;\n                  }\n\n                  .stat-value {\n                    font-size: 20px;\n                    font-weight: 700;\n                    color: #0f172a;\n                    margin: 0;\n                  }\n                }\n              }\n\n              .progress-bar-container {\n                width: 100%;\n                background-color: #e3f2fd;\n                border-radius: 9999px;\n                height: 6px;\n                overflow: hidden;\n                margin-bottom: 8px;\n\n                .progress-bar {\n                  height: 100%;\n                  background-color: #5fa2d8;\n                  border-radius: 9999px;\n                  transition: width 0.3s ease;\n                }\n              }\n\n              .progress-note {\n                font-size: 12px;\n                color: #64748b;\n                font-style: italic;\n                text-align: center;\n                margin: 0;\n              }\n            }\n\n            .feedback-section {\n              .feedback-list {\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n\n                .feedback-item {\n                  display: flex;\n                  align-items: center;\n                  justify-content: space-between;\n                  padding: 12px;\n                  border-radius: 8px;\n                  border: 1px solid rgba(95, 162, 216, 0.1);\n                  background-color: rgba(95, 162, 216, 0.05);\n\n                  &.feedback-negative {\n                    border-color: rgba(232, 62, 140, 0.1);\n                    background-color: rgba(232, 62, 140, 0.05);\n                  }\n\n                  .feedback-step {\n                    font-size: 14px;\n                    font-weight: 500;\n                    color: #0f172a;\n                  }\n\n                  .feedback-icon {\n                    color: #5fa2d8;\n                    font-size: 20px;\n                    width: 20px;\n                    height: 20px;\n\n                    &.feedback-icon-error {\n                      color: #e83e8c;\n                    }\n                  }\n                }\n              }\n            }\n\n            .notes-section {\n              .notes-textarea {\n                width: 100%;\n                background: white;\n                border: 1px solid #e2e8f0;\n                border-radius: 8px;\n                font-size: 14px;\n                padding: 12px;\n                color: #0f172a;\n                font-family: inherit;\n                resize: vertical;\n                transition: all 0.2s;\n                box-sizing: border-box;\n\n                &:focus {\n                  outline: none;\n                  border-color: #5fa2d8;\n                  box-shadow: 0 0 0 3px rgba(95, 162, 216, 0.1);\n                }\n\n                &::placeholder {\n                  color: #94a3b8;\n                }\n              }\n\n              .notes-hint {\n                font-size: 10px;\n                color: #64748b;\n                font-style: italic;\n                margin: 8px 0 0 0;\n              }\n            }\n          }\n        }\n      }\n\n      .modal-footer-new {\n        padding: 20px 24px;\n        background: #fafafa;\n        border-top: 1px solid #e0e0e0;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n\n        .response-section {\n          .response-label {\n            display: block;\n            font-size: 12px;\n            font-weight: 700;\n            text-transform: uppercase;\n            letter-spacing: 0.1em;\n            color: #94a3b8;\n            margin-bottom: 8px;\n          }\n\n          .response-textarea-new {\n            width: 100%;\n            background-color: #f8fafc;\n            border: 1px solid #e2e8f0;\n            border-radius: 12px;\n            font-size: 14px;\n            padding: 16px;\n            color: #0f172a;\n            font-family: inherit;\n            resize: vertical;\n            min-height: 100px;\n            transition: all 0.2s;\n            box-sizing: border-box;\n\n            &:focus {\n              outline: none;\n              border-color: #5fa2d8;\n              box-shadow: 0 0 0 3px rgba(95, 162, 216, 0.1);\n            }\n\n            &::placeholder {\n              color: #94a3b8;\n            }\n          }\n        }\n\n        .footer-actions {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          justify-content: space-between;\n          gap: 16px;\n          flex-wrap: nowrap;\n\n          .response-visibility {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            color: #64748b;\n            font-size: 12px;\n            white-space: nowrap;\n            flex-shrink: 0;\n\n            mat-icon {\n              font-size: 16px;\n              width: 16px;\n              height: 16px;\n            }\n          }\n\n          .footer-buttons {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            flex-shrink: 0;\n            white-space: nowrap;\n\n            .flag-btn,\n            .post-response-btn {\n              min-width: 140px;\n              height: 40px;\n              line-height: 40px;\n              padding-top: 0;\n              padding-bottom: 0;\n              margin: 0 !important;\n              white-space: nowrap !important;\n\n              .mdc-button__label {\n                white-space: nowrap !important;\n              }\n            }\n\n            .flag-btn {\n              background-color: #f3f4f6;\n              color: #374151;\n              font-weight: 600;\n              font-size: 14px;\n              border-radius: 8px;\n              padding: 10px 24px;\n              border: none;\n              display: inline-flex;\n              align-items: center;\n              justify-content: center;\n              gap: 8px;\n              transition: all 0.2s;\n              white-space: nowrap;\n              flex-shrink: 0;\n\n              &:hover {\n                background-color: #e5e7eb;\n              }\n\n              mat-icon {\n                font-size: 18px;\n                width: 18px;\n                height: 18px;\n              }\n            }\n\n            .post-response-btn {\n              background-color: #5fa2d8 !important;\n              color: white !important;\n              font-weight: 700 !important;\n              font-size: 14px !important;\n              border-radius: 8px !important;\n              padding: 10px 32px !important;\n              box-shadow: 0 4px 6px -1px rgba(95, 162, 216, 0.2) !important;\n              transition: all 0.2s !important;\n              white-space: nowrap !important;\n              flex-shrink: 0 !important;\n\n              &:hover {\n                background-color: #4a90c6 !important;\n                box-shadow: 0 6px 8px -1px rgba(95, 162, 216, 0.3) !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .reviews-list-card {\n    /* Match Access Requests card list layout */\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 20px;\n\n    .review-card-modern {\n      background-color: #fff;\n      border-radius: 16px;\n      border: 1px solid #e2e8f0;\n      box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n      overflow: hidden;\n      transition: all 0.3s ease;\n      box-sizing: border-box;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n\n      &:hover {\n        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);\n      }\n\n      .card-content {\n        padding: 24px;\n      }\n\n      .review-header-modern {\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n        margin-bottom: 24px;\n\n        @media (min-width: 640px) {\n          flex-direction: row;\n          justify-content: space-between;\n          align-items: flex-start;\n        }\n\n        .reviewer-info-modern {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n\n          .reviewer-avatar-modern {\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: white;\n            font-weight: 700;\n            font-size: 16px;\n            flex-shrink: 0;\n\n            &.reviewer-avatar-img {\n              object-fit: cover;\n              border: none;\n              padding: 0;\n            }\n          }\n\n          .reviewer-details-modern {\n            display: flex;\n            flex-direction: column;\n\n            .reviewer-name-modern {\n              margin: 0;\n              font-weight: 700;\n              font-size: 16px;\n              color: #0f172a;\n            }\n\n            .review-date-modern {\n              font-size: 12px;\n              color: #94a3b8;\n            }\n          }\n        }\n\n        .flow-link-modern {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          color: #5ea1d8;\n          text-decoration: none;\n          font-weight: 500;\n          font-size: 14px;\n          cursor: pointer;\n          transition: all 0.2s;\n\n          &:hover {\n            text-decoration: underline;\n          }\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n\n      .review-badges {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 12px;\n        margin-bottom: 16px;\n\n        .status-badge-modern {\n          display: inline-flex;\n          align-items: center;\n          gap: 6px;\n          padding: 6px 12px;\n          border-radius: 9999px;\n          font-size: 12px;\n          font-weight: 600;\n\n          &.completed {\n            background-color: #dcfce7;\n            color: #16a34a !important;\n          }\n\n          &.failed {\n            background-color: #fee2e2;\n            color: #dc2626 !important;\n          }\n\n          mat-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n          }\n        }\n\n      .star-rating {\n        display: flex;\n        gap: 2px;\n\n        .star-icon-modern {\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n          color: #d1d5db; // default grey for empty stars\n\n          &.filled {\n            color: #fbbf24; // golden for filled stars\n          }\n\n          &.half {\n            color: #fbbf24;\n          }\n        }\n      }\n      }\n\n      .review-content-grid {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 24px;\n        margin-bottom: 32px;\n\n        @media (min-width: 768px) {\n          grid-template-columns: 1fr 200px;\n        }\n\n        .review-text-modern {\n          p {\n            margin: 0;\n            color: #334155;\n            line-height: 1.75;\n            font-size: 15px;\n          }\n        }\n\n        .review-media-modern {\n          .media-preview {\n            position: relative;\n            overflow: hidden;\n            border-radius: 12px;\n            border: 1px solid #e2e8f0;\n            background-color: #f1f5f9;\n            cursor: pointer;\n            height: 128px;\n\n            img {\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n              transition: transform 0.3s ease;\n            }\n\n            &:hover:not(.has-error) img {\n              transform: scale(1.05);\n            }\n\n            .media-overlay {\n              position: absolute;\n              inset: 0;\n              background-color: rgba(0, 0, 0, 0.4);\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              opacity: 0;\n              transition: opacity 0.3s ease;\n              z-index: 1;\n\n              mat-icon {\n                font-size: 48px;\n                width: 48px;\n                height: 48px;\n                color: white;\n              }\n            }\n\n            &:hover:not(.has-error) .media-overlay {\n              opacity: 1;\n            }\n\n            .error-overlay {\n              position: absolute;\n              inset: 0;\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n              justify-content: center;\n              color: #94a3b8;\n              background-color: rgba(241, 245, 249, 0.5);\n              z-index: 2;\n\n              mat-icon {\n                font-size: 24px;\n                width: 24px;\n                height: 24px;\n                margin-bottom: 4px;\n              }\n\n              span {\n                font-size: 10px;\n                font-weight: 700;\n                text-transform: uppercase;\n              }\n            }\n\n            &.has-video {\n              .media-overlay {\n                opacity: 0;\n              }\n\n              &:hover .media-overlay {\n                opacity: 1;\n              }\n            }\n\n            &.has-error {\n              img {\n                opacity: 0.5;\n              }\n            }\n          }\n        }\n      }\n\n      .review-issues-modern {\n        margin-top: 24px;\n        padding-top: 24px;\n        border-top: 1px solid #f1f5f9;\n\n        h4 {\n          margin: 0 0 16px 0;\n          color: #0f172a;\n          font-size: 16px;\n          font-weight: 600;\n        }\n\n        .issue-item-modern {\n          margin-bottom: 24px;\n          padding: 16px;\n          background-color: #f9fafb;\n          border-radius: 12px;\n          border-left: 4px solid #ff9800;\n\n          .issue-header-modern {\n            margin-bottom: 8px;\n\n            strong {\n              color: #0f172a;\n            }\n          }\n\n          .issue-description-modern {\n            margin: 8px 0;\n            color: #64748b;\n            line-height: 1.6;\n          }\n\n          .issue-media-modern {\n            margin: 12px 0;\n            border-radius: 8px;\n            overflow: hidden;\n\n            img,\n            video {\n              max-width: 100%;\n              max-height: 300px;\n              object-fit: contain;\n            }\n          }\n\n          .issue-response-modern {\n            margin-top: 12px;\n            padding: 12px;\n            background-color: #dbeafe;\n            border-radius: 8px;\n\n            .response-header-modern {\n              display: flex;\n              align-items: center;\n              gap: 8px;\n              margin-bottom: 8px;\n\n              mat-icon {\n                font-size: 20px;\n                width: 20px;\n                height: 20px;\n                color: #5ea1d8;\n              }\n\n              strong {\n                color: #0f172a;\n              }\n\n              .response-date-modern {\n                margin-left: auto;\n                font-size: 12px;\n                color: #94a3b8;\n              }\n            }\n\n            p {\n              margin: 0;\n              color: #64748b;\n            }\n          }\n\n          .response-input-modern {\n            margin-top: 12px;\n\n            .full-width {\n              width: 100%;\n              margin-bottom: 8px;\n            }\n\n            .submit-btn-modern {\n              font-family: \"Raleway\" !important;\n              min-width: 140px !important;\n              height: 40px !important;\n              line-height: 40px !important;\n              padding: 0 24px !important;\n              margin: 0 !important;\n              font-weight: 600 !important;\n              text-transform: none !important;\n              border-radius: 8px !important;\n              background-color: #5fa2d8 !important;\n              color: white !important;\n              box-shadow: 0 4px 6px -1px rgba(95, 162, 216, 0.2) !important;\n              transition: all 0.2s !important;\n              white-space: nowrap !important;\n\n              .mdc-button__label {\n                white-space: nowrap !important;\n              }\n\n              &:hover {\n                background-color: #4a90c6 !important;\n                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15) !important;\n                transform: scale(0.98) !important;\n              }\n            }\n          }\n        }\n      }\n\n      .review-response-section {\n        margin-top: 32px;\n        padding-top: 24px;\n        border-top: 1px solid #f1f5f9;\n\n        .info-banner {\n          display: flex;\n          align-items: flex-start;\n          gap: 12px;\n          padding: 16px;\n          background-color: #dbeafe;\n          border-radius: 12px;\n          border: 1px solid #bfdbfe;\n          margin-bottom: 16px;\n\n          mat-icon {\n            color: #5ea1d8;\n            font-size: 20px;\n            width: 20px;\n            height: 20px;\n            flex-shrink: 0;\n          }\n\n          p {\n            margin: 0;\n            font-size: 14px;\n            color: #1e40af;\n            line-height: 1.5;\n          }\n        }\n\n        .review-response-modern {\n          margin-bottom: 16px;\n          padding: 12px;\n          background-color: #dbeafe;\n          border-radius: 8px;\n\n          .response-header-modern {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            margin-bottom: 8px;\n\n            mat-icon {\n              font-size: 20px;\n              width: 20px;\n              height: 20px;\n              color: #5ea1d8;\n            }\n\n            strong {\n              color: #0f172a;\n            }\n\n            .response-date-modern {\n              margin-left: auto;\n              font-size: 12px;\n              color: #94a3b8;\n            }\n          }\n\n          p {\n            margin: 0;\n            color: #64748b;\n            line-height: 1.6;\n          }\n        }\n\n        .response-input-modern {\n          .response-label {\n            display: block;\n            font-size: 14px;\n            font-weight: 600;\n            color: #334155;\n            margin-bottom: 8px;\n          }\n\n          .response-textarea {\n            width: 100%;\n            padding: 16px;\n            border-radius: 12px;\n            border: 1px solid #e2e8f0;\n            background-color: #f8fafc;\n            font-family: inherit;\n            font-size: 14px;\n            color: #0f172a;\n            resize: vertical;\n            transition: all 0.2s;\n            box-sizing: border-box;\n\n            &:focus {\n              outline: none;\n              border-color: #5ea1d8;\n              box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n            }\n\n            &::placeholder {\n              color: #94a3b8;\n            }\n          }\n\n          .response-actions {\n            margin-top: 16px;\n            display: flex;\n            justify-content: flex-end;\n\n            .submit-btn-modern {\n              font-family: \"Raleway\" !important;\n              min-width: 140px !important;\n              height: 40px !important;\n              line-height: 40px !important;\n              padding: 0 24px !important;\n              margin: 0 !important;\n              font-weight: 600 !important;\n              text-transform: none !important;\n              border-radius: 8px !important;\n              background-color: #5fa2d8 !important;\n              color: white !important;\n              box-shadow: 0 4px 6px -1px rgba(95, 162, 216, 0.2) !important;\n              transition: all 0.2s !important;\n\n              &:hover {\n                background-color: #4a90c6 !important;\n                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15) !important;\n                transform: scale(0.98) !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .reviews-list {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n      .review-card {\n      border: 1px solid #e0e0e0;\n      border-radius: 6px;\n      padding: 20px;\n      background-color: #fff;\n      box-shadow: 0 2px 4px rgba(15, 23, 42, 0.1);\n      box-sizing: border-box;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n\n      .review-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        margin-bottom: 16px;\n        padding-bottom: 16px;\n        border-bottom: 1px solid #e0e0e0;\n        gap: 12px;\n        min-width: 0;\n\n        .reviewer-info {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          min-width: 0;\n          flex: 1;\n\n          .reviewer-avatar {\n            width: 40px;\n            height: 40px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n\n          .reviewer-avatar-icon {\n            font-size: 40px;\n            width: 40px;\n            height: 40px;\n            color: #999;\n          }\n\n          .reviewer-details {\n            display: flex;\n            flex-direction: column;\n            min-width: 0;\n            flex: 1;\n\n            .reviewer-name {\n              font-weight: 500;\n              color: #333;\n              word-wrap: break-word;\n              overflow-wrap: break-word;\n              max-width: 100%;\n            }\n\n            .review-date {\n              font-size: 12px;\n              color: #999;\n              word-wrap: break-word;\n              overflow-wrap: break-word;\n            }\n          }\n        }\n\n        .flow-link {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          color: #5ea1d8;\n          cursor: pointer;\n          font-weight: 500;\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n          max-width: 50%;\n          min-width: 0;\n\n          &:hover {\n            text-decoration: underline;\n          }\n\n          mat-icon {\n            font-size: 20px;\n            width: 20px;\n            height: 20px;\n            flex-shrink: 0;\n          }\n\n          span {\n            word-wrap: break-word;\n            overflow-wrap: break-word;\n            min-width: 0;\n          }\n        }\n      }\n\n      .review-content {\n        .completion-status {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          margin-bottom: 16px;\n          padding: 8px 12px;\n          background-color: #f5f5f5;\n          border-radius: 4px;\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n\n          mat-icon {\n            &.completed {\n              color: #4caf50;\n            }\n\n            &.issues {\n              color: #ff9800;\n            }\n          }\n\n          span {\n            font-weight: 500;\n            color: #333;\n            word-wrap: break-word;\n            overflow-wrap: break-word;\n            max-width: 100%;\n          }\n        }\n\n        .review-text {\n          margin-bottom: 16px;\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n\n          p {\n            margin: 0;\n            color: #666;\n            line-height: 1.6;\n            word-wrap: break-word;\n            overflow-wrap: break-word;\n            max-width: 100%;\n          }\n        }\n\n        .review-media {\n          margin-bottom: 16px;\n          border-radius: 4px;\n          overflow: hidden;\n\n          img,\n          video {\n            max-width: 100%;\n            max-height: 400px;\n            object-fit: contain;\n          }\n        }\n\n        .review-issues {\n          margin-top: 16px;\n          padding-top: 16px;\n          border-top: 1px solid #e0e0e0;\n\n          h4 {\n            margin: 0 0 16px 0;\n            color: #333;\n            font-size: 16px;\n          }\n\n            .issue-item {\n            margin-bottom: 24px;\n            padding: 16px;\n            background-color: #f9f9f9;\n            border-radius: 6px;\n            border-left: 4px solid #ff9800;\n\n            .issue-header {\n              margin-bottom: 8px;\n              word-wrap: break-word;\n              overflow-wrap: break-word;\n\n              strong {\n                color: #333;\n                word-wrap: break-word;\n                overflow-wrap: break-word;\n                max-width: 100%;\n              }\n            }\n\n            .issue-description {\n              margin: 8px 0;\n              color: #666;\n              word-wrap: break-word;\n              overflow-wrap: break-word;\n              max-width: 100%;\n            }\n\n            .issue-media {\n              margin: 12px 0;\n              border-radius: 6px;\n              overflow: hidden;\n\n              img,\n              video {\n                max-width: 100%;\n                max-height: 300px;\n                object-fit: contain;\n              }\n            }\n\n            .issue-response {\n              margin-top: 12px;\n              padding: 12px;\n              background-color: #e3f2fd;\n              border-radius: 6px;\n\n              .response-header {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                margin-bottom: 8px;\n\n                mat-icon {\n                  font-size: 20px;\n                  width: 20px;\n                  height: 20px;\n                  color: #5ea1d8;\n                }\n\n                strong {\n                  color: #333;\n                }\n\n                .response-date {\n                  margin-left: auto;\n                  font-size: 12px;\n                  color: #999;\n                }\n              }\n\n              p {\n                margin: 0;\n                color: #666;\n                word-wrap: break-word;\n                overflow-wrap: break-word;\n                max-width: 100%;\n              }\n            }\n\n            .response-input {\n              margin-top: 12px;\n\n              .full-width {\n                width: 100%;\n                margin-bottom: 8px;\n\n                ::ng-deep .mat-mdc-form-field {\n                  width: 100%;\n                }\n\n                ::ng-deep .mat-mdc-text-field-wrapper {\n                  width: 100%;\n                }\n              }\n\n              button.mat-raised-button {\n                font-family: \"Raleway\" !important;\n                min-width: 100px !important;\n                height: auto !important;\n                min-height: auto !important;\n                font-weight: normal !important;\n                text-transform: none !important;\n                letter-spacing: normal !important;\n                border-radius: 10px !important;\n                transition: all 0.3s ease !important;\n                padding: 10px !important;\n                border: none !important;\n                cursor: pointer !important;\n                line-height: 1.5 !important;\n                margin-top: 8px !important;\n                display: inline-flex !important;\n                align-items: center !important;\n                justify-content: center !important;\n                box-sizing: border-box !important;\n                color: white !important;\n                background-color: #5ea1d8 !important;\n                box-shadow: none !important;\n                white-space: nowrap !important;\n                overflow: hidden !important;\n                text-overflow: ellipsis !important;\n                text-align: center !important;\n                font-size: 15px !important;\n                \n                ::ng-deep .mat-button-wrapper,\n                ::ng-deep .mdc-button__label {\n                  white-space: nowrap !important;\n                  overflow: hidden !important;\n                  text-overflow: ellipsis !important;\n                  text-align: center !important;\n                  display: inline-block !important;\n                  line-height: 1.5 !important;\n                }\n\n                &:hover {\n                  background-color: #4a90c6 !important;\n                }\n\n                &:active {\n                  background-color: #3a7fb6 !important;\n                }\n              }\n            }\n          }\n        }\n\n        .review-response {\n          margin-top: 16px;\n          padding: 12px;\n          background-color: #e3f2fd;\n          border-radius: 6px;\n\n          .response-header {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            margin-bottom: 8px;\n\n            mat-icon {\n              font-size: 20px;\n              width: 20px;\n              height: 20px;\n              color: #5ea1d8;\n            }\n\n            strong {\n              color: #333;\n            }\n\n            .response-date {\n              margin-left: auto;\n              font-size: 12px;\n              color: #999;\n            }\n          }\n\n          p {\n            margin: 0;\n            color: #666;\n          }\n        }\n\n        .response-input {\n          margin-top: 16px;\n          padding-top: 16px;\n          border-top: 1px solid #e0e0e0;\n\n          .full-width {\n            width: 100%;\n            margin-bottom: 12px;\n\n            ::ng-deep .mat-mdc-form-field {\n              width: 100%;\n            }\n\n            ::ng-deep .mat-mdc-text-field-wrapper {\n              width: 100%;\n            }\n          }\n\n          button.mat-raised-button {\n            font-family: \"Raleway\" !important;\n            min-width: 100px !important;\n            height: auto !important;\n            min-height: auto !important;\n            font-weight: normal !important;\n            text-transform: none !important;\n            letter-spacing: normal !important;\n            border-radius: 10px !important;\n            transition: all 0.3s ease !important;\n            padding: 10px !important;\n            border: none !important;\n            cursor: pointer !important;\n            line-height: 1.5 !important;\n            margin-top: 8px !important;\n            display: inline-flex !important;\n            align-items: center !important;\n            justify-content: center !important;\n            box-sizing: border-box !important;\n            color: white !important;\n            background-color: #5ea1d8 !important;\n            box-shadow: none !important;\n            white-space: nowrap !important;\n            overflow: hidden !important;\n            text-overflow: ellipsis !important;\n            text-align: center !important;\n            font-size: 15px !important;\n            \n            ::ng-deep .mat-button-wrapper,\n            ::ng-deep .mdc-button__label {\n              white-space: nowrap !important;\n              overflow: hidden !important;\n              text-overflow: ellipsis !important;\n              text-align: center !important;\n              display: inline-block !important;\n              line-height: 1.5 !important;\n            }\n\n            &:hover {\n              background-color: #4a90c6 !important;\n            }\n\n            &:active {\n              background-color: #3a7fb6 !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  // Align layout with other dashboard pages on mobile\n  .setting-dashboard {\n    .submission-field {\n      width: 100%;\n      left: 0;\n      position: relative;\n    }\n  }\n\n  .dashbored-wrap .table-wrap {\n    padding: 0;\n  }\n\n  .com-record {\n    padding: 12px 16px 20px;\n  }\n\n  /* Search and filter bar: full width on mobile (global) */\n  .filter,\n  .filters-section {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n  }\n  .filters-section {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding: 0 20px;\n  }\n  .filters-section .search-and-flow-filter,\n  .filters-section .flow-filter {\n    flex: 1 1 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .filters-section .search-field,\n  .filters-section .search-field ::ng-deep .mat-mdc-form-field,\n  .filters-section .search-field ::ng-deep .mat-mdc-text-field-wrapper {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  .flow-reviews-container {\n    padding: 0;\n\n    /* Flow analytics graph cards: single column, full width, chart responsive */\n    .flow-analytics-section {\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n    }\n    .flow-analytics-grid {\n      display: grid !important;\n      grid-template-columns: 1fr !important;\n      gap: 16px;\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n    }\n    .flow-analytics-card {\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n      padding: 12px 12px 16px;\n      overflow: hidden;\n    }\n    .flow-analytics-card-header .flow-title-link {\n      word-break: break-word;\n      display: block;\n    }\n    .flow-analytics-card app-flow-analytics-chart,\n    .flow-analytics-card ::ng-deep .flow-analytics-chart,\n    .flow-analytics-card ::ng-deep .chart-container {\n      display: block !important;\n      width: 100% !important;\n      max-width: 100% !important;\n      box-sizing: border-box;\n    }\n    .flow-analytics-card ::ng-deep .chart-container canvas {\n      max-width: 100% !important;\n      height: auto !important;\n    }\n\n    // Table view on mobile: keep it scrollable horizontally\n    .table-view-container {\n      overflow-x: auto;\n\n      .table-action-bar {\n        flex-direction: column;\n        gap: 12px;\n        align-items: flex-start;\n\n        .table-actions {\n          flex-wrap: wrap;\n        }\n      }\n\n      .reviews-table {\n        min-width: 800px;\n      }\n    }\n\n    .reviews-list {\n      margin-top: 16px;\n\n      .review-card-modern {\n        border-radius: 12px;\n        padding: 16px;\n\n        .review-header-modern {\n          flex-direction: column;\n          gap: 12px;\n        }\n      }\n\n      .review-card {\n        .review-header {\n          flex-direction: column;\n          gap: 12px;\n\n          .flow-link {\n            align-self: flex-start;\n          }\n        }\n      }\n    }\n\n    .review-details-overlay {\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      padding: 8px;\n      align-items: flex-start;\n      justify-content: center;\n\n      .review-details-modal {\n        max-height: 95vh;\n        max-width: calc(100vw - 16px);\n        width: 100%;\n        border-radius: 16px;\n        margin: 8px;\n\n        .modal-header-new {\n          padding: 16px;\n\n          .header-user-details {\n            .header-user-name {\n              font-size: 16px;\n              padding-right: 40px;\n            }\n\n            .header-flow-name {\n              font-size: 12px;\n            }\n          }\n\n          .close-btn-new {\n            top: 8px;\n            right: 8px;\n          }\n        }\n\n        .modal-body-new {\n          .modal-grid {\n            .modal-left-column {\n              padding: 16px;\n            }\n          }\n        }\n\n        .modal-footer-new {\n          padding: 16px;\n        }\n      }\n    }\n  }\n}\n\n/* Flow name dropdown panel: keep inside viewport and scroll */\n/* For Angular Material v15+ where panelClass is applied to the panel element */\n::ng-deep .mat-mdc-select-panel.flow-filter-select-panel,\n/* Fallback for older versions where panelClass is on the overlay pane */\n::ng-deep .cdk-overlay-pane.flow-filter-select-panel .mat-mdc-select-panel {\n  z-index: 1100 !important;\n  max-height: min(70vh, 400px) !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  max-width: min(420px, calc(100vw - 32px)) !important;\n  width: auto !important;\n}\n\n/* Long flow titles: truncate with ellipsis so panel width stays under control */\n::ng-deep .mat-mdc-select-panel.flow-filter-select-panel .mat-mdc-option .mdc-list-item__primary-text,\n::ng-deep .cdk-overlay-pane.flow-filter-select-panel .mat-mdc-option .mdc-list-item__primary-text {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  display: block !important;\n}\n\n\n\n// ==============================================\n// DARK MODE\n// ==============================================\n:host-context(body.theme-dark) {\n  .dashbored-wrap,\n  .setting-dashboard,\n  .scroll-div,\n  .flow-reviews-container,\n  .com-record,\n  .table-wrap,\n  .table-view-container,\n  .filter,\n  .filters-section,\n  .search-input,\n  .detail-list {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  // Flow analytics chart cards\n  .flow-analytics-card {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    .flow-analytics-card-header { border-color: rgba(148, 163, 184, 0.2) !important; }\n    .flow-title-link { color: #93c5fd !important; }\n    p, span:not(.material-icons):not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]), h4 { color: #e5e7eb !important; }\n  }\n\n  // Table\n  table, thead, tbody, tr, td {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  th {\n    background: #0f172a !important;\n    background-color: #0f172a !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  tbody tr:hover { background: #1f2937 !important; }\n\n  .box {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    color: #e5e7eb !important;\n  }\n\n  p, span:not(.material-icons):not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]), label, li, h1, h2, h3, h4, h5, h6, i, b {\n    color: #e5e7eb !important;\n  }\n\n  .mobile-design {\n    background: #0f172a !important;\n    .tile { background: #1f2937 !important; border-color: rgba(148, 163, 184, 0.25) !important; }\n  }\n\n  // Shimmer\n  .skeleton-text { background: linear-gradient(90deg, #1f2937 25%, #374151 37%, #1f2937 63%) !important; background-size: 400% 100% !important; }\n\n  // Review card (modern)\n  .reviews-list .review-card-modern {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    .review-header-modern { border-color: rgba(148, 163, 184, 0.2) !important; }\n    .flow-name-modern { color: #93c5fd !important; }\n    .reviewer-name-modern { color: #f1f5f9 !important; }\n    .review-date-modern { color: #94a3b8 !important; }\n    .review-comment-modern { color: #cbd5e1 !important; }\n  }\n\n  // Review details overlay / modal\n  .review-details-overlay { background: rgba(0,0,0,0.7) !important; }\n  .review-details-modal {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    .modal-header-new { background: #0f172a !important; border-color: rgba(148, 163, 184, 0.2) !important; }\n    .header-user-name { color: #f1f5f9 !important; }\n    .header-flow-name { color: #94a3b8 !important; }\n    .modal-body-new { background: #1f2937 !important; }\n    .modal-footer-new { background: #0f172a !important; border-color: rgba(148, 163, 184, 0.2) !important; }\n    .review-issues-modern .issue-item-modern {\n      background: #0f172a !important;\n      .issue-header-modern strong { color: #f1f5f9 !important; }\n      .issue-description-modern { color: #94a3b8 !important; }\n    }\n  }\n\n  // Filter dropdown\n  .filters-section .status-filter {\n    background: #0f172a !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  // Custom flow-name search dropdown panel\n  .flow-filter-dropdown-panel {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;\n  }\n\n  .flow-dropdown-option {\n    background: #0f172a !important;\n    color: #e2e8f0 !important;\n\n    .option-icon {\n      color: #5ea1d8 !important;\n    }\n\n    &:hover {\n      background-color: rgba(148, 163, 184, 0.12) !important;\n    }\n\n    &.selected {\n      background-color: rgba(94, 161, 216, 0.18) !important;\n      color: #93c5fd !important;\n    }\n  }\n\n  .flow-dropdown-empty {\n    color: #94a3b8 !important;\n  }\n}\n\n\n// ════════════════════════════════════════════════\n// DARK MODE – direct body.theme-dark rules\n// These compile to body.theme-dark .class[_ngcontent-xxx]\n// which reliably overrides all hardcoded whites.\n// ════════════════════════════════════════════════\nbody.theme-dark .dashbored-wrap,\nbody.theme-dark .setting-dashboard {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .top-menu-wrap,\nbody.theme-dark .dashbored-wrap .box,\nbody.theme-dark .dashbored-wrap .card,\nbody.theme-dark .dashbored-wrap .mat-mdc-card,\nbody.theme-dark .dashbored-wrap .tile,\nbody.theme-dark .dashbored-wrap .com-record,\nbody.theme-dark .dashbored-wrap .table-wrap,\nbody.theme-dark .dashbored-wrap .detail-list,\nbody.theme-dark .dashbored-wrap .filter,\nbody.theme-dark .dashbored-wrap .search-input,\nbody.theme-dark .dashbored-wrap .tab-content,\nbody.theme-dark .dashbored-wrap .followers-tag .box {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap table,\nbody.theme-dark .dashbored-wrap thead,\nbody.theme-dark .dashbored-wrap tbody,\nbody.theme-dark .dashbored-wrap tr,\nbody.theme-dark .dashbored-wrap td {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap th {\n  background: var(--fc-bg-head) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap tbody tr:hover {\n  background: var(--fc-bg-hover) !important;\n}\n\nbody.theme-dark .dashbored-wrap input,\nbody.theme-dark .dashbored-wrap select,\nbody.theme-dark .dashbored-wrap textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design .tile {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap [class*=\"skeleton-\"] {\n  background: var(--fc-skel) !important;\n  color: transparent !important;\n}\n\nbody.theme-dark .dashbored-wrap p,\nbody.theme-dark .dashbored-wrap label,\nbody.theme-dark .dashbored-wrap li,\nbody.theme-dark .dashbored-wrap h1,\nbody.theme-dark .dashbored-wrap h2,\nbody.theme-dark .dashbored-wrap h3,\nbody.theme-dark .dashbored-wrap h4,\nbody.theme-dark .dashbored-wrap h5,\nbody.theme-dark .dashbored-wrap h6 {\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=\"status\"]) {\n  color: var(--fc-fg) !important;\n}\nbody.theme-dark .reviews-table {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\nbody.theme-dark .reviews-table td,\nbody.theme-dark .reviews-table th {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\nbody.theme-dark .stat-card {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\nbody.theme-dark .notes-textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\nbody.theme-dark .review-card {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\n/* ── Direct body.theme-dark additions (flow-reviews page) ── */\n\n/* Summary stat cards */\nbody.theme-dark .flow-reviews-stats.followers-tag .box {\n  background: var(--fc-bg2) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .flow-reviews-stats.followers-tag .box .text .count {\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\nbody.theme-dark .flow-reviews-stats.followers-tag .box .text .count b { color: #f1f5f9 !important; }\nbody.theme-dark .flow-reviews-stats.followers-tag .box .text p { color: #94a3b8 !important; }\n\n/* Flow analytics cards */\nbody.theme-dark .flow-analytics-card {\n  background: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .flow-analytics-card .analytics-count-badge {\n  background: #374151 !important;\n  color: #94a3b8 !important;\n}\n\n/* Table action bar */\nbody.theme-dark .table-action-bar {\n  background-color: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .table-action-bar .selected-count { color: var(--fc-fg) !important; }\n\nbody.theme-dark .table-action-bar .btn-secondary {\n  background-color: #374151 !important;\n  color: #e5e7eb !important;\n}\n\n/* Modern review cards */\nbody.theme-dark .reviews-list-card .review-card-modern,\nbody.theme-dark .reviews-list .review-card-modern {\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .review-card-modern .reviewer-name-modern { color: #f1f5f9 !important; }\nbody.theme-dark .review-card-modern .review-date-modern { color: #94a3b8 !important; }\nbody.theme-dark .review-card-modern .review-text-modern p { color: #cbd5e1 !important; }\nbody.theme-dark .review-card-modern .review-header-modern { border-color: rgba(148, 163, 184, 0.2) !important; }\n\nbody.theme-dark .review-card-modern .review-issues-modern { border-color: rgba(148, 163, 184, 0.2) !important; }\nbody.theme-dark .review-card-modern .issue-item-modern {\n  background: #0f172a !important;\n}\n\nbody.theme-dark .review-card-modern .issue-description-modern { color: #94a3b8 !important; }\nbody.theme-dark .review-card-modern .issue-response-modern { background: rgba(59, 130, 246, 0.1) !important; }\n\nbody.theme-dark .review-card-modern .review-response-section { border-color: rgba(148, 163, 184, 0.2) !important; }\nbody.theme-dark .review-card-modern .review-response-modern { background: rgba(59, 130, 246, 0.1) !important; }\nbody.theme-dark .review-card-modern .response-textarea { background: #0f172a !important; color: var(--fc-fg) !important; border-color: var(--fc-border) !important; }\n\n/* Old review card */\nbody.theme-dark .reviews-list .review-card .review-header { border-color: rgba(148, 163, 184, 0.2) !important; }\nbody.theme-dark .reviews-list .review-card .completion-status { background: #374151 !important; }\nbody.theme-dark .reviews-list .review-card .review-text p { color: #cbd5e1 !important; }\nbody.theme-dark .reviews-list .review-card .issue-item { background: #0f172a !important; }\nbody.theme-dark .reviews-list .review-card .issue-response,\nbody.theme-dark .reviews-list .review-card .review-response { background: rgba(59, 130, 246, 0.1) !important; }\n\n/* Review details modal */\nbody.theme-dark .review-details-modal {\n  background: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .review-details-modal .modal-header-new {\n  background: #0f172a !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .review-details-modal .modal-right-column {\n  background-color: #0f172a !important;\n}\n\nbody.theme-dark .review-details-modal .modal-footer-new {\n  background: #0f172a !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .review-details-modal .rating-status-section {\n  background-color: #374151 !important;\n}\n\nbody.theme-dark .review-details-modal .header-user-name { color: #f1f5f9 !important; }\nbody.theme-dark .review-details-modal .header-flow-name { color: #94a3b8 !important; }\nbody.theme-dark .review-details-modal .review-title-modal { color: #f1f5f9 !important; }\nbody.theme-dark .review-details-modal .review-text-modal { color: #cbd5e1 !important; }\nbody.theme-dark .review-details-modal .review-date-modal { color: #94a3b8 !important; }\nbody.theme-dark .review-details-modal .section-title { color: #64748b !important; }\nbody.theme-dark .review-details-modal .notes-textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .review-details-modal .response-textarea-new {\n  background-color: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .review-details-modal .response-label { color: #64748b !important; }\n\nbody.theme-dark .review-details-modal .flag-btn {\n  background-color: #374151 !important;\n  color: #e5e7eb !important;\n}\n\n/* Skeleton containers */\nbody.theme-dark .skeleton-box {\n  background: var(--fc-bg2) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .skeleton-tile,\nbody.theme-dark .skeleton-table-container,\nbody.theme-dark .skeleton-mobile-container {\n  background: var(--fc-bg2) !important;\n}\n/* ── Override global white-background globals (.table-card, .fc-table, .big-box, .filter-section) ── */\nbody.theme-dark .table-card {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;\n}\nbody.theme-dark .big-box {\n  background: #111827 !important;\n  background-color: #111827 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .fc-table {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .fc-table thead th {\n  background-color: #0f172a !important;\n  background: #0f172a !important;\n  color: #94a3b8 !important;\n  border-bottom-color: rgba(148, 163, 184, 0.25) !important;\n  border-right-color: rgba(148, 163, 184, 0.15) !important;\n}\nbody.theme-dark .fc-table tbody td {\n  background-color: #1f2937 !important;\n  color: #e2e8f0 !important;\n  border-top-color: rgba(148, 163, 184, 0.15) !important;\n  border-right-color: rgba(148, 163, 184, 0.1) !important;\n}\nbody.theme-dark .fc-table tbody tr:nth-child(even) td {\n  background-color: #253347 !important;\n}\nbody.theme-dark .fc-table tbody tr:hover td {\n  background-color: #374151 !important;\n  color: #f1f5f9 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\nbody.theme-dark .filter-section {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .filter-section label {\n  color: #94a3b8 !important;\n}\nbody.theme-dark .filter-section select,\nbody.theme-dark .filter-section input {\n  background: #0f172a !important;\n  background-color: #0f172a !important;\n  color: #e2e8f0 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\n\n/* ── Stat card count white-bg fix (highest specificity override) ── */\nbody.theme-dark .com-record .followers-tag .box {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\nbody.theme-dark .com-record .followers-tag .box .text .count {\n  background: transparent !important;\n  background-color: transparent !important;\n}\nbody.theme-dark .com-record .followers-tag .box .text .count b {\n  color: #f1f5f9 !important;\n}\nbody.theme-dark .com-record .followers-tag .box .text p {\n  color: #94a3b8 !important;\n}\nbody.theme-dark .com-record .followers-tag .box .card-icon {\n  color: #5ea1d8 !important;\n}\n\n/* ── Dark scrollbars and overflow area fix ── */\nbody.theme-dark .table-parent {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar,\nbody.theme-dark .table-card::-webkit-scrollbar {\n  background: #111827;\n  width: 6px;\n  height: 6px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-track,\nbody.theme-dark .table-card::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-corner,\nbody.theme-dark .table-card::-webkit-scrollbar-corner {\n  background: #111827;\n}\n\n/* ── Status badge dark mode overrides (table view) ── */\nbody.theme-dark .status-badge.completed {\n  background-color: #052e16 !important;\n  color: #86efac !important;\n}\nbody.theme-dark .status-badge.failed {\n  background-color: #450a0a !important;\n  color: #fca5a5 !important;\n}\n\n/* ── Status badge dark mode overrides (card view) ── */\nbody.theme-dark .status-badge-modern.completed {\n  background-color: #052e16 !important;\n  color: #86efac !important;\n}\nbody.theme-dark .status-badge-modern.failed {\n  background-color: #450a0a !important;\n  color: #fca5a5 !important;\n}\n\n/* ── Analytics count badge ── */\nbody.theme-dark .analytics-count-badge {\n  background: #374151 !important;\n  color: #94a3b8 !important;\n}\n\n/* ── Custom flow-name search dropdown panel ── */\nbody.theme-dark .flow-filter-dropdown-panel {\n  background: #0f172a !important;\n  border-color: rgba(148, 163, 184, 0.25) !important;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;\n}\n\nbody.theme-dark .flow-dropdown-option {\n  background: #0f172a !important;\n  color: #e2e8f0 !important;\n}\n\nbody.theme-dark .flow-dropdown-option:hover {\n  background-color: rgba(148, 163, 184, 0.12) !important;\n}\n\nbody.theme-dark .flow-dropdown-option.selected {\n  background-color: rgba(94, 161, 216, 0.18) !important;\n  color: #93c5fd !important;\n}\n\n/* ── Star rating: keep golden in dark mode ── */\nbody.theme-dark .rating-cell .star-icon,\nbody.theme-dark .star-icon-modal.filled,\nbody.theme-dark .star-icon-modal.half,\nbody.theme-dark .star-icon-modern.filled,\nbody.theme-dark .star-icon-modern.half {\n  color: #ffc107 !important;\n}\n\nbody.theme-dark .star-icon-modal:not(.filled):not(.half),\nbody.theme-dark .star-icon-modern:not(.filled):not(.half) {\n  color: #4b5563 !important;\n}\n\nbody.theme-dark .flow-dropdown-empty {\n  color: #94a3b8 !important;\n}\n\n/* Native select / status filter */\nbody.theme-dark .status-filter,\nbody.theme-dark .filters-section .status-filter {\n  background: #0f172a !important;\n  color: #e2e8f0 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\n\n/* ── Modal status badge dark mode (flow details modal header) ── */\nbody.theme-dark .status-badge-modal {\n  background: #1e3a5f !important;\n  color: #93c5fd !important;\n}\n\nbody.theme-dark .status-badge-modal.completed {\n  background: #052e16 !important;\n  color: #86efac !important;\n}\n\nbody.theme-dark .status-badge-modal.failed {\n  background: #450a0a !important;\n  color: #fca5a5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
